import React from 'react';
import * as moment from 'moment';
import { Button, Checkbox, DatePicker, Form, Icon, Input, InputNumber, Select, Tooltip } from 'antd';
import RelationshipSearchFilter from "../components/RelationshipSearchFilter";
import SearchFilter from "../components/SearchFilter";
import MasterModal from "../components/MasterModal";
import SubMasterModal from "../components/SubMasterModal";
import SuperMasterModal from "../components/SuperMasterModal";
import FieldSearchForm from "../components/FieldSearchForm";

const { RangePicker } = DatePicker;

export const isUrlMatchingDomain = (url, domain, subdomain) => {
  const regex = new RegExp(`^(https?://)?${subdomain}\\.${domain}`, 'i');
  return regex.test(url);
}
export const getCurrentDomainAndSubdomain = () => {
  const { hostname } = window.location;

  // Split the hostname by dot (.)
  const hostnameParts = hostname.split('.');

  // Assuming the last two parts of the hostname are the domain and subdomain
  const domain = hostnameParts.slice(-2).join('.');
  const subdomain = hostnameParts.slice(0, -2).join('.');

  return { domain, subdomain };
}

export const createDebounce = (fn) => {
  if (typeof fn !== 'function') {
    throw new TypeError('createDebounce expects a function');
  }
  const DEFAULT_DEBOUNCE_WAIT = 700;

  let timeoutId = null;
  let lastArgs;
  let lastThis;
  let lastResult;

  const invoke = () => {
    timeoutId = null;
    lastResult = fn.apply(lastThis, lastArgs);
    lastArgs = undefined;
    lastThis = undefined;
    return lastResult;
  };

  const debounced = function (...args) {
    lastArgs = args;
    lastThis = this;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(invoke, DEFAULT_DEBOUNCE_WAIT);
    return lastResult;
  };

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    lastArgs = undefined;
    lastThis = undefined;
  };

  debounced.flush = () => {
    if (!timeoutId) {
      return lastResult;
    }
    clearTimeout(timeoutId);
    return invoke();
  };

  return debounced;
}

export const sanitizeFieldName = (fieldName) => {
  return fieldName.replace('_', '')
    .replace(/^\w/, c => c.toUpperCase())
    .replace(/([a-z])([A-Z])/g, '$1 $2');
  // .replace(/([A-Z])([a-z])/g, '$1 $2');
};
export const getRenderForFieldByType = function (value, type, item = '', isDateTime = false) {
  // console.log('item  ' + item, type);
  switch (type) {
    case 'Number':
      if (item === 'invoiceValue' || item === 'rate') {
        return (value || 0).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        })
      }
      if (item === 'readingTime' || item === 'lastIotReadingTime' || item === 'readingDateTs') {
        const correctedTimestamp = value && value.toString().length === 10 ? Number(value) * 1000 : Number(value);
        return correctedTimestamp && moment(correctedTimestamp).local().format('DD-MM-YYYY HH:mm:ss');
      }
      return (value || 0);
    case 'Boolean':
      return value ? <Tooltip title="True"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
        <Tooltip title="False"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>;
    case 'String':

      if (item === 'jobCard.statusTitle' || item === 'jobCard.presentStatus') {
        if (value && value === 'ClosedPendingInvoice') {
          return 'Closed - Pending Invoice';
        } else if (value && value === 'ClosedPendingInvoiceReopen') {
          return 'Closed - Pending Invoice - Reopened';
        } else {
          return value || '';
        }
      }
      return value || '';
    case 'Date':
      if (item === 'createdAt' || item === 'updatedAt') {
        return value ? moment(value || '').format('DD-MM-YYYY hh:mm a') : '';
      }
      if (isDateTime) {
        return value ? moment(value || '').format('DD-MM-YYYY hh:mm:ss a') : '';
      }
      return value ? moment(value || '').format('DD-MM-YYYY') : '';
    case 'ObjectID':
      if (item === 'prevContract' || item === 'nextContract') {
        return value && value.id || '';
      }

      if (item === 'jobCard' || item === 'fromParentJobCard' || item === 'toParentJobCard') {
        return value && value.jobCardNo;
      }

      if (item === 'pvNo') {
        return value && value.pvNo ? value.pvNo : '';
      }

      if (item === 'ata') {
        return value && value.ataNo ? value.ataNo : '';
      }

      if (item === 'sta') {
        return value && value.staNo ? value.staNo : '';
      }

      if (item === 'meter') {
        return value && value.meterNo ? value.meterNo : '';
      }

      if (item === 'auditVoucher') {
        return value && value.voucherNo ? value.voucherNo : '';
      }

      if (Array.isArray(value)) {
        return value.map(item => item.name).join(',');
      }

      if (value && value.name) {
        return value.name;
      }

      if (value && value.complaintNo) {
        return value.complaintNo;
      }

      if (value && value.assetCode) {
        return value.assetCode;
      }

      if (value && value.serviceIdentifierName) {
        return value.serviceIdentifierName;
      }
      return value;

    case 'Array':
      if ((item === 'assetDetails' || item === 'tasks') && typeof value === 'object' && value.length)
        return value.length;
      else if (item === 'schedules')
        return value && value.map(itm => itm && itm.serviceIdentifierNo ? itm.serviceIdentifierNo : '').join(',');
      else if (item === 'timeIntervals')
        return value && value.map(itm => itm ? `${itm.value} ${itm.name}` : '').join(',');
      else if (item === 'mileage') {
        return value && value.map(itm => ((itm.name && itm.reading) ? itm.reading + ' ' + itm.name : itm.unit ? itm.reading + ' ' + itm.unit.name || '' : '')).join(',');
        // return value && value.map(itm => ((itm.name && itm.reading) ? itm.reading + ' ' + itm.name : itm.unit ? itm.reading + ' ' + itm.unit.name || '' : '').concat(itm && itm.meterReadingRecord ? ` (${Number(itm.meterReadingRecord.calculatedReading).toFixed(2)})` : '')).join(',');
      } else if (item === 'standardFuelConsumptionRate') {
        return value && value.map(itm => {
          if (itm.perType && itm.perType.name && itm.fuelQty) {
            const qty = itm.perType.name === 'HOURS' ? itm.fuelQty : 1 / itm.fuelQty;
            const title = itm.perType.name === 'HOURS' ? `L/${itm.perType.name}` : `${itm.perType.name}/L`;
            return `${qty} ${title}`
          }
          return ''
        }).join(', ');
      } else if (item === 'fuelMileageThreshold') {
        return value && value.map(itm => {
          if (itm.perType && itm.perType.name && itm.value) {
            const title = itm.perType.name === 'HOURS' ? `L/${itm.perType.name}` : `${itm.perType.name}/L`;
            return `${itm.value}% ${title}`
          }
          return ''
        }).join(', ');
      } else {
        // console.log(item, value)
        return value && value.map(itm => {
          if (!itm) return '';
          if (typeof itm === 'string' || typeof itm === 'number') return itm;
          if (itm.role) return itm.role;
          if (itm.name && itm.reading) return `${itm.reading} ${itm.name}`;
          if (itm.unit) return `${itm.reading} ${itm.unit.name}`;
          return itm.name;
        }).join(',');
      }
    default:
      return value;
  }
};

export const arrayToCSV = function (input, filter, columns) {
  // console.log('input', input)
  // console.log('filter', filter)
  // console.log('columns', columns)
  // for PV and AST
  (input || []).forEach(doc => {
    if (doc.hasOwnProperty('assetDetails'))
      doc['assetDetails'] = doc['assetDetails'] && doc['assetDetails'].length;
  });
  const CSV_SEPARATOR = ';';
  const headers = getHeaders(input, columns);
  const lines = getLines(input, headers);
  // console.log('headers', headers)
  // console.log('lines', lines)

  for (let i in headers) {
    if (headers[i] === "client") {
      headers[i] = "subLocation";
    }
    if (headers[i] === "equipmentSubType") {
      headers[i] = "assetSubType";
    }
    if (headers[i] === "idealFuelConsumptionRate") {
      headers[i] = "Idle Fuel Consumption Rate(L/Hr)";
    }
    headers[i] = sanitizeFieldName(headers[i]);
  }

  return [headers.join(CSV_SEPARATOR)].concat(lines).join('\n');

  function getRenderForFieldByTypeForCsv(value, type, item = '') {
    switch (type) {
      case 'String':
        return value || '--';
      case 'Date':
        return value ? moment(value || '').format('DD-MM-YYYY hh:mm a') : '--';
      case 'ObjectID':
        if (Array.isArray(value)) {
          return value.map(item => item.name).join(',');
        }
        if (value && value.name) {
          return value.name;
        }
        if (value && value.assetCode) {
          return value.assetCode;
        }
        if (value && value.ataNo) {
          return value.ataNo;
        }
        if (value && value.staNo) {
          return value.staNo;
        }
        if (value && value.complaintNo) {
          return value.complaintNo;
        }
        if (value && value.pvNo) {
          return value.pvNo;
        }
        if (value && value.jobCardNo) {
          return value.jobCardNo;
        }
        if (value && value.meterNo) {
          return value.meterNo;
        }
        if (value && value.readingNo) {
          return value.readingNo;
        }
        return value || '--';
      case 'Array':
        // console.log('item', item)
        // console.log('value', value)
        if (item && item === 'standardFuelConsumptionRate') {
          return value && value.map(itm => {
            if (itm.perType && itm.perType.name && itm.fuelQty) {
              const qty = itm.perType.name === 'HOURS' ? itm.fuelQty : 1 / itm.fuelQty;
              const title = itm.perType.name === 'HOURS' ? `L/${itm.perType.name}` : `${itm.perType.name}/L`;
              return `${qty} ${title}`
            }
            return ''
          }).join('| ');
        } else if (item === 'fuelMileageThreshold') {
          return value && value.map(itm => {
            if (itm.perType && itm.perType.name && itm.value) {
              const title = itm.perType.name === 'HOURS' ? `L/${itm.perType.name}` : `${itm.perType.name}/L`;
              return `${itm.value}% ${title}`
            }
            if (itm.value) {
              return `${itm.value}%`
            }
            return ''
          }).join('| ');
        }
        return (value && value.length) ? `${value.length} Nos` : '-';
      default:
        return value || `--`;
    }
  }

  function getHeaders(input, columns) {
    // console.log('input', input)
    // console.log('columns', columns)
    const headers = new Set();
    columns = JSON.parse(columns);
    columns.map(key => {
      if (filter[key] && filter[key].type) { //&& filter[key].type !== 'Array'
        headers.add(key);
      } else if (key === 'jobCard') {
        headers.add(key)
      }
      if (key === 'assetDetails')
        headers.add(key)
    });
    return Array.from(headers);
  }

  function getLines(input, headers) {
    // console.log('headers', headers)
    return input.map(function (obj) {
      return headers.map(function (head) {
        // console.log('head', head)
        let val = null;
        let newHead = head;
        if (newHead.includes('.')) {
          const nameKey = newHead.split('.');
          val = getRenderForFieldByTypeForCsv(obj[nameKey[0]][nameKey[1]], filter[head].type, head);
          return (val || '');
        }
        val = getRenderForFieldByTypeForCsv(obj[head], (filter[head] && filter[head].type) || 'String', head);

        return (val || '');
      }).join(CSV_SEPARATOR);
    });
  }
}

export const downloadCSV = function (str, name = "") {
  // console.log(str)
  var hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(str);
  hiddenElement.target = '_blank';
  hiddenElement.download = `${name}_List_${Date.now()}.csv`;
  hiddenElement.click();
}

export const getColumnSearchProps = (data, handleFilter, handleReset, resourceName) =>
  ((data && data.showFilter === false) || (data && data.options && data.options.showFilter === false)) ? null : ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      if (data.type === 'String') {
        return (
          <SearchFilter resourceName={resourceName} data={data} handleFilter={handleFilter}
            handleReset={handleReset}
            setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm}
            clearFilters={clearFilters} />
        );
        // <div style={{padding: 8}}>
        //   <Input
        //     placeholder={`Search ${sanitizeFieldName(data.field)}`}
        //     value={selectedKeys[0]}
        //     onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        //     onPressEnter={() => handleFilter(selectedKeys, confirm, data)}
        //     style={{width: 188, marginBottom: 8, display: 'block'}}
        //   />
        //   <Button
        //     type="primary"
        //     onClick={() => handleFilter(selectedKeys, confirm, data)}
        //     icon="search"
        //     size="small"
        //     style={{width: 90, marginRight: 8}}
        //   >
        //     Search
        //   </Button>
        //   <Button onClick={() => handleReset(clearFilters, data)} size="small" style={{width: 90}}>
        //     Reset
        //   </Button>
        // </div>
      }

      if (data.type === 'Date') {
        return (
          <div style={{ padding: 8, display: 'flex', flexDirection: 'column' }}>
            <RangePicker
              style={{ marginBottom: 8 }}
              format={'DD-MM-YYYY'}
              onChange={(date, dateString) => {
                // console.log('data', dataStrings);
                setSelectedKeys([date]);
                handleFilter(date, confirm, data);
              }} />

            {/*<DatePicker*/}
            {/*  style={{marginBottom: 8}}*/}
            {/*  format={'DD-MM-YYYY'}*/}
            {/*  onChange={(date, dateString) => {*/}
            {/*    setSelectedKeys([date]);*/}
            {/*    handleFilter(date, confirm, data);*/}
            {/*  }}/>*/}
            <Button onClick={() => handleReset(clearFilters, data)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        );
      }

      if (data.type === 'Boolean') {
        return (
          <div style={{ padding: 8, display: 'flex', flexDirection: 'column' }}>
            <Checkbox
              checked={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.checked ? [e.target.checked] : [false])}
              onPressEnter={() => handleFilter(selectedKeys, confirm, data)}
              style={{ margin: 8, display: 'block' }}
            > </Checkbox>
            <Button
              type="primary"
              onClick={() => handleFilter(selectedKeys, confirm, data)}
              icon="search"
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters, data)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        );
      }

      if (data.type === 'ObjectID' && data.options.ref) {
        return (
          <RelationshipSearchFilter data={data} handleFilter={handleFilter} handleReset={handleReset}
            setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters} />
        );
      }

      return (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${sanitizeFieldName(data.field)}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleFilter(selectedKeys, confirm, data)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => handleFilter(selectedKeys, confirm, data)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters, data)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      );
    },
  });

export const getFormFieldByType = (filters, item, getFieldDecorator, data, otherDetails = {}) => {
  // console.log(item, filters[item].options);
  if (item !== 'organisation') {
    const dataKey = item.split('.')[1] ? item.split('.')[1] : item;
    const dataKeyObj = item.split('.')[1] ? item.split('.')[0] : null;
    const value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;
    const refName = filters && filters[item] && filters[item].options && filters[item].options.ref;

    if (refName === 'Asset' || refName === 'SparePart') {
      return <FieldSearchForm
        title={otherDetails && otherDetails.title}
        otherDetails={otherDetails || {}}
        options={filters && filters[item] && filters[item].options}
        key={item}
        name={item}
        label={sanitizeFieldName(item)}
        message={`${sanitizeFieldName(item)} is required`}
        required={filters[item].required}
        disabled={((otherDetails && otherDetails.title) === 'EDIT' && filters[item] && filters[item].options.disabledOnEdit) || false}
        field={filters && filters[item] && filters[item].options && filters[item].options.main}
        model={filters && filters[item] && filters[item].options && filters[item].options.ref}
        initialValue={data && data[item]}
        getFieldDecorator={getFieldDecorator}
        setFieldsValue={(otherDetails && otherDetails.setFieldsValue)}
        onChange={(otherDetails && otherDetails.onChange)}
      />
    }

    if (otherDetails && otherDetails.resource && otherDetails.resource === 'AssetModel' && item === 'code' && otherDetails.title === 'CREATE') {
      return;
    }
    if (filters[item].type === 'String' && item !== 'tpwNo' && !filters[item].options.hidden && !filters[item].options.enum) {
      return <Form.Item key={item} style={otherDetails && otherDetails.resource === 'PreVerification' ? {
        width: '48%',
        marginRight: '2%'
      } : {}}
        label={
          <span>{sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
            {filters[item].options.description ?
              (<Tooltip title={filters[item].options.description}>
                <Icon type="question-circle-o" />
              </Tooltip>) : null}
          </span>}>
        {getFieldDecorator(item, {
          rules: [{
            required: filters[item].required,
            message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
          }],
          initialValue: item !== 'password' ? value : '',
        })(<Input
          placeholder={`Please Enter ${sanitizeFieldName(filters[item].field)}`}
          disabled={(otherDetails && otherDetails.resource === 'AssetModel' && item === 'code') ? true :
            (otherDetails && otherDetails.title === 'EDIT' && otherDetails.qrScanned) ? true :
              (otherDetails && otherDetails.title === 'EDIT' && filters[item].options.disabledOnEdit)}
          autoComplete={'off'} />)
        }
      </Form.Item>;
    }

    if (filters[item].type === 'String' && !filters[item].options.hidden && filters[item].options.enum) {
      // console.log(filters[item].options);
      return <Form.Item key={item} style={otherDetails && otherDetails.resource === 'PreVerification' ? {
        width: '48%',
        marginRight: '2%'
      } : {}}
        label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
        {getFieldDecorator(item, {
          rules: [{
            required: filters[item].required,
            message: `${filters[item].options.label ? filters[item].options.label : item} is required!`
          }],
          initialValue: item !== 'password' ? value : '',
        })(<Select
          onChange={(otherDetails && otherDetails.onChange)}
          allowClear
          placeholder={`Please select ${sanitizeFieldName(filters[item].field)}`}
          disabled={otherDetails && otherDetails.title === 'EDIT' && filters[item].options.disabledOnEdit}
        >
          {filters[item].options.enum.map(item => <Select.Option key={item}
            value={item}>{item}</Select.Option>)}
        </Select>)
        }
      </Form.Item>;
    }

    if (filters[item].type === 'Date' && !filters[item].options.hidden) {
      return <Form.Item key={item}
        style={otherDetails && otherDetails.resource === 'PreVerification' ? { width: '48%' } : {}}
        label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
        {getFieldDecorator(item, {
          rules: [{
            required: filters[item].required,
            message: `${filters[item].options.label ? filters[item].options.label : item} is required!`
          }],
          initialValue: value && moment(value),
        })(<DatePicker
          disabledDate={otherDetails.disabledDate}
          disabled={otherDetails && otherDetails.resource === 'EmployeeAssetIssue' && otherDetails.title === 'EDIT' ? true
            : otherDetails && otherDetails.title === 'EDIT' && (otherDetails.resource === 'ThirdPartyWorkRequirement' ||
              otherDetails.resource === 'ThirdPartyWorkQuotation' || otherDetails.resource === 'SparesIssue' || otherDetails.resource === 'Meter') ? true :
              otherDetails && otherDetails.title === 'EDIT' && otherDetails.qrScanned} />)
        }
      </Form.Item>;
    }
    if (filters[item].options.hidden && filters[item].options.viewOnly && otherDetails && otherDetails.title === 'EDIT') {
      if (filters[item].type === 'Number') {
        return <Form.Item key={'view_' + item}
          label={
            <span>{sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
              {filters[item].options.description ?
                (<Tooltip title={filters[item].options.description}>
                  <Icon type="question-circle-o" />
                </Tooltip>) : null}
            </span>}>
          {getFieldDecorator('view_' + item, {
            rules: [],
            initialValue: value,
          })(<Input type='number'
            disabled={true} autoComplete={'off'}
          />)
          }
        </Form.Item>;
      }
    }

    if (filters[item].type === 'Number' && !filters[item].options.hidden && item !== 'phoneNumber') {
      if (filters[item].field === 'rate') {
        return <Form.Item key={item}
          label={
            <span>{sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
              {filters[item].options.description ?
                (<Tooltip title={filters[item].options.description}>
                  <Icon type="question-circle-o" />
                </Tooltip>) : null}
            </span>}>
          {getFieldDecorator(item, {
            rules: [{
              required: filters[item].required,
              message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
            }],
            initialValue: value,
          })(<Input type='number'
            step="0.01"
            disabled={otherDetails && otherDetails.title === 'EDIT' && filters[item].options.disabledOnEdit}
            // onWheel={(e) => e.target.blur()}
            //onWheel={() => document.activeElement.blur()}
            onWheel={event => event.currentTarget.blur()}
            autoComplete={'off'}
          />)
          }
        </Form.Item>;
      } else {
        return <Form.Item key={item} style={otherDetails && otherDetails.resource === 'PreVerification' ? {
          width: '48%',
          marginRight: '2%'
        } : {}}
          label={<span>
            {sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
            {filters[item].options.description ?
              (<Tooltip title={filters[item].options.description}>
                <Icon type="question-circle-o" />
              </Tooltip>) : null}
          </span>}>
          {getFieldDecorator(item, {
            rules: [{
              required: filters[item].required,
              message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
            }],
            initialValue: value ? value : 0,
          })(<Input type='number'
            disabled={otherDetails && otherDetails.title === 'EDIT' && filters[item].options.disabledOnEdit}
            // onWheel={(e) => e.target.blur()}
            //onWheel={() => document.activeElement.blur()}
            onWheel={event => event.currentTarget.blur()}
            autoComplete={'off'}
          />)
          }
        </Form.Item>;
      }
    }

    if (filters[item].type === 'Array' && item !== 'documents' && filters[item].options.enum) {
      return <Form.Item key={item}
        label={<span>
          {sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
          {filters[item].options.description ? (
            <Tooltip title={filters[item].options.description}>
              <Icon type="question-circle-o" />
            </Tooltip>)
            : null}
        </span>}>
        {getFieldDecorator(item, {
          rules: [{
            required: filters[item].required,
            message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
          }],
          initialValue: (value && value.length) ? value.map(field => field) : [],
        })(<Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Please select"
        >
          {filters[item].options.enum.map(itm => <Select.Option key={itm}
            value={itm}>{itm}</Select.Option>)}
        </Select>)
        }
      </Form.Item>;
    }

    if (filters[item].type === 'Array' && item !== 'documents' && filters[item].options.ref) {
      return <Form.Item key={item}
        label={<span>
          {sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
          {filters[item].options.description ? (
            <Tooltip title={filters[item].options.description}>
              <Icon type="question-circle-o" />
            </Tooltip>)
            : null}
        </span>}>
        {getFieldDecorator(item, {
          rules: [{
            required: filters[item].required,
            message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
          }],
          initialValue: (value && value.length) ? value.map(field => field._id) : [],
        })(<Select
          showSearch
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Please select"
          filterOption={(input, option) =>
            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
          }
        >
          {filters[item].data.data.map(itm => <Select.Option key={itm._id}
            value={itm._id}>{itm.role ? itm.role : filters[item].options && filters[item].options.main ? itm[filters[item].options.main] : itm.name}</Select.Option>)}
        </Select>)
        }
      </Form.Item>;
    }

    if (filters[item].type === 'ObjectID' && item !== '_id' && !filters[item].options.hidden) {
      const hideCreateForField = !!(otherDetails && Array.isArray(otherDetails.hideMasterForFields)
        && otherDetails.hideMasterForFields.includes(item));
      const showMasterCreate = filters[item].options.master && !hideCreateForField;
      const showSuperMasterCreate = !!filters[item].options.superMaster && !hideCreateForField;
      const needsCreateButtonSpace = showMasterCreate || showSuperMasterCreate;

      return <Form.Item key={item} label={
        <span>{sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
          {filters[item].options.description ?
            (<Tooltip title={filters[item].options.description}>
              <Icon type="question-circle-o" />
            </Tooltip>) : null}
        </span>}>
        {getFieldDecorator(item, {
          rules: [{
            required: (otherDetails && otherDetails.onEditOptional && otherDetails.onEditOptional === 'yes') ? false : filters[item].required,
            message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
          }],
          initialValue: (item === 'assetSubType' && otherDetails.assetSubType) ? otherDetails.assetSubType._id
            : (item === 'owner' && otherDetails && otherDetails.owner) ? otherDetails.owner
            : otherDetails && otherDetails.dependent && otherDetails.title === 'CREATE' ? otherDetails.owner : value && value._id,
        })(<Select
          showSearch
          allowClear
          mode="single"
          style={otherDetails && otherDetails.resource === 'PreVerification' && item !== 'user' ? { width: '75%' } :
            (otherDetails && otherDetails.resource === 'PreVerification' && item === 'user') ? { width: '100%' } : needsCreateButtonSpace ? {
              width: '80%',
              marginTop: '-10px'
            } : { width: '100%' }}
          filterOption={(input, option) =>
            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
          }
          placeholder="Please select"
          disabled={(otherDetails && (otherDetails.title === 'EDIT' || otherDetails.title === 'VIEW') && filters[item].options.disabledOnEdit)
            || (item === 'owner' && !!(otherDetails && otherDetails.owner))}
        >
          {filters[item].data.data.map(item => !item.isHidden && <Select.Option key={item._id}
            value={item._id}>{item.name}</Select.Option>)}
        </Select>)}
        {
          showMasterCreate ? (item === 'assetType' && otherDetails && otherDetails.resource === 'EquipmentSubType' && otherDetails.pvModule === true) ?
            <SubMasterModal pvModule={(otherDetails && otherDetails.pvModule) || false}
              superMaster={(otherDetails && otherDetails.superMaster) || false}
              resource={(otherDetails && otherDetails.resource)}
              item={filters[item].options.ref}
              title={'CREATE'} /> :
            <MasterModal subMaster={(otherDetails && otherDetails.subMaster) || false}
              superMaster={(otherDetails && otherDetails.superMaster) || false}
              pvModule={(otherDetails && otherDetails.pvModule) || false}
              resource={(otherDetails && otherDetails.resource)}
              item={filters[item].options.ref}
              title={'CREATE'} /> : ''

        }
        {
          showSuperMasterCreate ?
            <SuperMasterModal resource={(otherDetails && otherDetails.resource)}
              item={filters[item].options.ref}
              title={'CREATE'} /> : ''
        }
      </Form.Item>;
    }

    if (filters[item].type === 'Boolean' && !filters[item].options.hidden) {
      return <Form.Item key={item}
        label={
          <span>{sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
            {filters[item].options.description ?
              (<Tooltip title={filters[item].options.description}>
                <Icon type="question-circle-o" />
              </Tooltip>) : null}</span>}>
        {getFieldDecorator(item, {
          rules: [{
            required: !filters[item].requiredAtAdmin ? filters[item].requiredAtAdmin : filters[item].required,
            message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
          }],
          valuePropName: 'checked',
          initialValue: !!value || (otherDetails && otherDetails.title !== 'EDIT' && otherDetails.defaultValueType
            && otherDetails.defaultValueType === 'Boolean' && otherDetails.defaultValue),
        })(<Checkbox />)
        }
      </Form.Item>;
    }

    // if (filters[item].type === 'Array' && item === 'documents' && filters[item].options.ref) {
    //   return <Form.Item key={item} label={sanitizeFieldName(item)}>
    //     {getFieldDecorator(item, {
    //       rules: [{ required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` }],
    //       initialValue: (value && value.length) ? value.map(field => field._id) : [],
    //     })(<Upload.Dragger name="files" action="/upload.do">
    //       <p className="ant-upload-drag-icon">
    //         <Icon type="inbox"/>
    //       </p>
    //       <p className="ant-upload-text">Click or drag file to this area to upload</p>
    //       <p className="ant-upload-hint">Support for a single or bulk upload.</p>
    //     </Upload.Dragger>)
    //     }
    //   </Form.Item>;
    // }
  }

};

export const getFormFieldByTypeForTpwModule = (filters, item, getFieldDecorator, data, otherDetails) => {
  let sumValue = 0;
  if (item !== 'organisation') {
    const dataKey = item.split('.')[1] ? item.split('.')[1] : item;
    const dataKeyObj = item.split('.')[1] ? item.split('.')[0] : null;


    let value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;
    const refName = filters && filters[item] && filters[item].options && filters[item].options.ref;
    if (refName === 'Asset' || refName === 'SparePart') {
      return <FieldSearchForm
        title={otherDetails && otherDetails.title}
        otherDetails={otherDetails || {}}
        options={filters && filters[item] && filters[item].options}
        key={item}
        name={item}
        label={sanitizeFieldName(item)}
        message={`${sanitizeFieldName(item)} is required`}
        required={true}
        disabled={((otherDetails && otherDetails.title) === 'EDIT' && filters[item] && filters[item].options.disabledOnEdit) || false}
        field={filters && filters[item] && filters[item].options && filters[item].options.main}
        model={filters && filters[item] && filters[item].options && filters[item].options.ref}
        initialValue={data && data[item]}
        getFieldDecorator={getFieldDecorator}
        setFieldsValue={(otherDetails && otherDetails.setFieldsValue)}
      />
    }

    if (filters[item].type === 'Date' && !filters[item].options.hidden) {
      return <div key={item} style={{ width: '48%' }}>
        <Form.Item key={item}
          label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
          {getFieldDecorator(item, {
            rules: [{
              required: filters[item].required,
              message: `${filters[item].options.label ? filters[item].options.label : item} is required!`
            }],
            initialValue: value && moment(value),
          })(<DatePicker style={{ width: '95%' }}
            disabled={otherDetails && (otherDetails.resource === 'EmployeeAssetIssue' || otherDetails.resource === 'SparesIssue') && otherDetails.title === 'EDIT' ? true
              : otherDetails && otherDetails.title === 'EDIT' && (otherDetails.resource === 'ThirdPartyWorkRequirement' ||
                otherDetails.resource === 'ThirdPartyWorkQuotation') ? true : otherDetails && otherDetails.disableMaster ? true :
                otherDetails && otherDetails.title === 'EDIT' && otherDetails.qrScanned} />)
          }
        </Form.Item>
      </div>;
    }


    if (filters[item].type === 'String' && item !== 'tpwNo' && !filters[item].options.hidden && !filters[item].options.enum) {
      return <div key={item} style={{ width: '46%', marginRight: '2%' }}>
        <Form.Item key={item}
          label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
          {getFieldDecorator(item, {
            rules: [{
              required: filters[item].required,
              message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
            }],
            initialValue: item !== 'password' ? value : '',
          })(<Input type="text"
            disabled={(otherDetails && otherDetails.title === 'EDIT' && filters[item].options.disabledOnEdit)}
            autoComplete={'off'} />)
          }
        </Form.Item>
      </div>
    }

    if (filters[item].type === 'Number' && !filters[item].options.hidden) {
      if (otherDetails && otherDetails.resource !== 'invoiceEntry') {
        if (item === 'totalCost' && otherDetails && otherDetails.spareValue && otherDetails.labourValue) {
          sumValue = 0;
          otherDetails.spareValue.map(item => {
            sumValue = sumValue + item;
          });

          otherDetails.labourValue.map(itm => {
            sumValue = sumValue + itm;
          });
        }
        return <div key={item} style={{ width: '48%' }}>
          <Form.Item key={item}
            label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
            {getFieldDecorator(item, {
              rules: [{
                required: filters[item].required,
                message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
              }],
              initialValue: value ? value : sumValue ? sumValue : 0,
            })(<Input type='number'
              // onWheel={event => {event.preventDefault()}}
              //onWheel={() => document.activeElement.blur()}
              onWheel={event => event.currentTarget.blur()}
              disabled={(otherDetails && otherDetails.resource && otherDetails.resource === 'ThirdPartyWorkQuotation') ? true : otherDetails && otherDetails.disableMaster ? true : false}
              // onWheel={(e) => e.target.blur()}
              autoComplete={'off'}
            />)
            }
          </Form.Item>
        </div>;
      }
    }

    if (filters[item].type === 'Array' && item !== 'documents' && filters[item].options.ref) {
      return <Form.Item key={item}
        label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
        {getFieldDecorator(item, {
          rules: [{
            required: filters[item].required,
            message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
          }],
          initialValue: (value && value.length) ? value.map(field => field._id) : [],
        })(<Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Please select"
        >
          {filters[item].data.data.map(item => <Select.Option key={item._id}
            value={item._id}>{item.role ? item.role : item.name}</Select.Option>)}
        </Select>)
        }
      </Form.Item>;
    }

    if (filters[item].type === 'ObjectID' && item !== '_id' && !filters[item].options.hidden) {
      return <div key={item}
        style={otherDetails && (otherDetails.checked || otherDetails.warranty) && item === 'vendor' ? { width: '100%' } : { width: '48%' }}>
        <Form.Item key={item} label={sanitizeFieldName(filters[item].options.label ?
          filters[item].options.label : item)}>
          {getFieldDecorator(item, {
            rules: [{
              required: filters[item].required,
              message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
            }], initialValue: value && value._id,
          })(<Select
            showSearch
            allowClear
            mode="single"
            style={(filters[item].options.master || filters[item].options.superMaster) ? {
              width: '80%',
              marginTop: '-10px'
            } : { width: '100%' }}
            filterOption={(input, option) =>
              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            }
            placeholder="Please select"
            disabled={otherDetails && otherDetails.title === 'EDIT' && filters[item].options.disabledOnEdit}
          >
            {filters[item].data.data.map(item => <Select.Option key={item._id}
              value={item._id}>{item.name}</Select.Option>)}
          </Select>)}
          {
            filters[item].options.master ?
              <MasterModal subMaster={(otherDetails && otherDetails.subMaster) || false}
                superMaster={(otherDetails && otherDetails.superMaster) || false}
                resource={(otherDetails && otherDetails.resource)}
                item={filters[item].options.ref} title={'CREATE'}
                disableAll={otherDetails && otherDetails.disableMaster} /> : ''
          }
          {
            filters[item].options.superMaster ?
              <SuperMasterModal resource={(otherDetails && otherDetails.resource)}
                item={filters[item].options.ref}
                title={'CREATE'} /> : ''
          }
        </Form.Item>
      </div>;
    }
  }
};

export const getSubFormFieldByTypeForTpwModule = (model, getFieldDecorator, data, key, field, index, otherDetails) => {
  if (model.type === 'String' && !model.options.hidden && !model.options.enum) {
    return <div key={key} style={{ width: '48%' }}>
      <Form.Item key={key}
        label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field)
          : otherDetails && (otherDetails.resource === 'ThirdPartyWorkQuotation' || otherDetails.resource === 'InvoiceEntry') ?
            sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
        {getFieldDecorator(`${field}[${index}][${model.field}]`, {
          rules: [{
            required: model.required,
            message: `${model.options.label ? model.options.label : model.field} is required!`
          }],
          initialValue: (data ? data[model.field] : ''),
        })(<Input style={{ marginRight: 8 }} disabled={otherDetails && otherDetails.disableAll}
          placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
          autoComplete={'off'} />)
        }
      </Form.Item>
    </div>;
  }

  if (model.type === 'Boolean' && !model.options.hidden) {
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        valuePropName: 'checked',
        initialValue: (data ? data[model.field] : false),
      })(<Checkbox>{sanitizeFieldName(model.options.label ? model.options.label : model.field)}</Checkbox>)
      }
    </Form.Item>;
  }

  if (model.type === 'String' && !model.options.hidden && model.options.enum) {
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: data ? data[model.field] : '',
      })(<Select
        disabled={otherDetails && otherDetails.disableAll}
        placeholder={`Please select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.options.enum.map(item => <Select.Option key={item}
          value={item}>{item}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  if (model.type === 'Date' && !model.options.hidden) {
    return <div key={key} style={{ width: '48%' }}><Form.Item key={key}
      label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: data && data[model.field] && moment(data[model.field]),
      })(<DatePicker disabled={otherDetails && otherDetails.disableAll} />)
      }
    </Form.Item>
    </div>;
  }

  if (model.type === 'Number' && !model.options.hidden) {
    return <div key={key} style={{ width: '48%' }}>
      <Form.Item key={key} label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
        {getFieldDecorator(`${field}[${index}][${model.field}]`, {
          rules: [{
            required: model.required,
            message: `${model.options.label ? model.options.label : model.field} is required!`
          }],
          initialValue: (data ? data[model.field] : ''),
        })(<Input type='number'
          // onWheel={event => {event.preventDefault()}}
          //onWheel={() => document.activeElement.blur()}
          onWheel={event => event.currentTarget.blur()}
          onChange={(e, ind, modelField, fields, masterField) => {
            otherDetails.handleSubChange(e, index, model.field, `${field}[${index}][${model.field}]`, field)
          }} placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
          style={{ marginRight: 8 }}
          disabled={(model.field && model.field === 'totalCost') || (otherDetails && otherDetails.disableAll)}
          autoComplete={'off'} />)
        }
      </Form.Item>
    </div>;
  }

  if (model.type === 'Array' && model.field !== 'documents' && model.options && model.options.ref) {
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: (data && data.length) ? data.map(field => field._id) : [],
      })(<Select
        mode="multiple"
        placeholder={`Please ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.data.data.map(item => <Select.Option key={item._id}
          value={item._id}>{item.role}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  if (model.type === 'ObjectID' && model.field !== '_id' && model.field !== 'complaint') {
    if (model.field !== 'sparePart') {
      return <div key={key} style={{ width: '48%' }}>
        <Form.Item key={key}
          label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field)
            : otherDetails && (otherDetails.resource === 'ThirdPartyWorkQuotation' || otherDetails.resource === 'InvoiceEntry') ?
              sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
          {getFieldDecorator(`${field}[${index}][${model.field}]`, {
            rules: [{
              required: model.required,
              message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
            }],
            initialValue: data && data[model.field] ? data[model.field]._id
              : model.field === 'unitOfMeasurement' && otherDetails && otherDetails.title === 'CREATE' && otherDetails.uom !== false ? otherDetails.uom : ''
          })(<Select
            showArrow={false}
            showSearch
            allowClear
            mode="single"
            disabled={model.field === 'unitOfMeasurement' || (otherDetails && otherDetails.title === 'EDIT' && model && model.options.disabledOnEdit) || otherDetails && otherDetails.disableAll || false}
            style={model.options.master ? { width: '80%', marginTop: '-10px' } : { width: '100%' }}
            filterOption={(input, option) =>
              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            }
            onChange={(value) => {
              if (model.field === 'labour' && otherDetails && otherDetails.handleSpareOrLabourSelect) {
                otherDetails.handleSpareOrLabourSelect(value, index, 'labour');
              }
            }}
            placeholder={model.field === 'unitOfMeasurement' ? 'Unit Of Measurement' :
              `Please Select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
          >
            {model.data && model.data.data && model.data.data.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
            }
          </Select>)
          }
          {
            model.options.master ?
              <MasterModal superMaster={(otherDetails && otherDetails.superMaster) || false}
                subMaster={(otherDetails && otherDetails.subMaster) || false}
                resource={(otherDetails && otherDetails.resource)}
                item={model.options.ref}
                title={'CREATE'}
                disableAll={otherDetails && otherDetails.disableAll} /> : model.options.superMaster ?
                <SuperMasterModal superMaster={(otherDetails && otherDetails.superMaster) || false}
                  subMaster={(otherDetails && otherDetails.subMaster) || false}
                  resource={(otherDetails && otherDetails.resource)}
                  item={model.options.ref}
                  title={'CREATE'}
                  disableAll={otherDetails && otherDetails.disableAll} /> : ''
          }
        </Form.Item>
      </div>;
    }
    if (model.field && model.field === 'sparePart') {
      return <div key={key} style={{ width: '48%' }}>
        <FieldSearchForm
          title={otherDetails && otherDetails.title}
          otherDetails={otherDetails}
          options={model && model.options}
          key={key}
          name={`${field}[${index}][${model.field}]`}
          label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field)
            : otherDetails && (otherDetails.resource === 'ThirdPartyWorkQuotation' || otherDetails.resource === 'InvoiceEntry') ?
              sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}
          message={`${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`}
          onSelect={(value, ind) => {
            otherDetails && otherDetails.onSpareSelect(value, index);
            if (otherDetails && otherDetails.handleSpareOrLabourSelect) {
              otherDetails.handleSpareOrLabourSelect(value, index, 'sparePart');
            }
          }}
          required={model.required}
          disabled={(otherDetails && otherDetails.title === 'EDIT' && model && model.options.disabledOnEdit) || false}
          showArrow={false}
          field={model && model.options.main}
          model={model && model.options.ref}
          placeholder={'Search Spare Parts'}
          initialValue={data && data[model.field]}
          getFieldDecorator={otherDetails && otherDetails.getFieldDecorator}
          setFieldsValue={otherDetails && otherDetails.setFieldsValue}
          disableAll={otherDetails && otherDetails.disableAll}
          excludedIds={otherDetails && otherDetails.excludedSpareIds}
          formIndex={index} />
      </div>;
    }
    if (otherDetails && otherDetails.resource === 'ThirdPartyWorkQuotation') {
      return <div key={'empty'} style={{ width: '48%' }}>
      </div>
    }
  }
};

export const getSubFormFieldByTypeForPv = (model, getFieldDecorator, data, key, field, index, otherDetails) => {
  if (model.type === 'String' && !model.options.hidden && !model.options.enum && !otherDetails.checked) {
    return <Form.Item key={key}
      label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: (data ? data[model.field] : ''),
      })(<Input style={{ marginRight: 8, width: '75%' }}
        disabled={otherDetails && otherDetails.tempAssetCode !== ''}
        placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
        autoComplete={'off'} />)
      }
    </Form.Item>;
  }

  if (model.type === 'Boolean' && !model.options.hidden) {
    return <Form.Item key={key}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        valuePropName: 'checked',
        initialValue: (data ? data[model.field] : false),
      })(<Checkbox disabled={(otherDetails && otherDetails.tempAssetCode !== '') || (otherDetails && otherDetails.countableLocked)}
        onClick={otherDetails.changeCountable}>{sanitizeFieldName(model.options.label ? model.options.label : model.field)}</Checkbox>)
      }
    </Form.Item>;
  }

  if (model.type === 'String' && !model.options.hidden && model.options.enum && otherDetails && !otherDetails.checked) {
    return <Form.Item key={key}
      label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: data ? data[model.field] : '',
      })(<Select allowClear disabled={otherDetails && otherDetails.tempAssetCode !== ''}
        style={{ marginRight: 8, width: '75%' }}
        placeholder={`Please select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.options.enum.map(item => <Select.Option key={item}
          value={item}>{item}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  if (model.type === 'Date' && !model.options.hidden) {
    return <Form.Item key={key} label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: data && data[model.field] && moment(data[model.field]),
      })(<DatePicker />)
      }
    </Form.Item>;
  }

  if (model.type === 'Number' && !model.options.hidden && otherDetails && otherDetails.checked) {
    return <Form.Item key={key}
      label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: (data ? data[model.field] : ''),
      })(<Input type='number'
        disabled={otherDetails && otherDetails.tempAssetCode !== ''}
        placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
        style={{ marginRight: 8, width: '75%' }}
        //onWheel={() => document.activelement.blur()}
        onWheel={event => event.currentTarget.blur()}
        autoComplete={'off'}
      />)
      }
    </Form.Item>;
  }

  if (model.type === 'Array' && model.field !== 'documents' && model.options && model.options.ref) {
    return <Form.Item key={key}
      label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: (data && data.length) ? data.map(field => field._id) : [],
      })(<Select
        mode="multiple"
        disabled={otherDetails && otherDetails.tempAssetCode !== ''}
        placeholder={`Please ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.data.data.map(item => <Select.Option key={item._id}
          value={item._id}>{item.role}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  if (model.type === 'ObjectID' && model.field !== '_id' && model.field !== 'complaint' && !model.options.hidden && otherDetails && !otherDetails.checked && model.field !== 'physicalCondition') {
    return <Form.Item key={key} label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: data && data[model.field] && data[model.field]._id,
      })(<Select
        showSearch
        allowClear
        disabled={otherDetails && otherDetails.tempAssetCode !== ''}
        mode="single"
        style={model.options.master ? { width: '75%' } : { width: '75%' }}
        filterOption={(input, option) =>
          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
        }
        placeholder={`Please Select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.data && model.data.data && model.data.data.map(item => <Select.Option key={item._id}
          value={item._id}>{item.name}</Select.Option>)}
      </Select>)
      }
      {
        model.options.master ? <MasterModal superMaster={(otherDetails && otherDetails.superMaster) || false}
          subMaster={(otherDetails && otherDetails.subMaster) || false}
          resource={(otherDetails && otherDetails.resource)}
          item={model.options.ref}
          title={'CREATE'} /> : ''
      }
    </Form.Item>;
  }

  if (model.type === 'ObjectID' && model.field !== '_id' && model.field !== 'complaint' && !model.options.hidden && model.field !== 'assetCustodian') {
    return <Form.Item key={key} label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${field}[${index}][${model.field}]`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: data && data[model.field] && data[model.field]._id,
      })(<Select
        showSearch
        allowClear
        disabled={otherDetails && otherDetails.tempAssetCode !== ''}
        mode="single"
        style={model.options.master ? { width: '75%' } : { width: '75%' }}
        filterOption={(input, option) =>
          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
        }
        placeholder={`Please Select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.data && model.data.data && model.data.data.map(item => <Select.Option key={item._id}
          value={item._id}>{item.name}</Select.Option>)}
      </Select>)
      }
      {
        model.options.master ? <MasterModal superMaster={(otherDetails && otherDetails.superMaster) || false}
          subMaster={(otherDetails && otherDetails.subMaster) || false}
          resource={(otherDetails && otherDetails.resource)}
          item={model.options.ref}
          title={'CREATE'} /> : ''
      }
    </Form.Item>;
  }
};

export const getSubFormFieldByType = (model, getFieldDecorator, data, key, field, index, otherDetails) => {

  let name = `${field}[${index}][${model.field}]`;
  if (otherDetails.parent) {
    name = `${otherDetails.parent}[${field}[${index}][${model.field}]]`;
  }

  if (model.type === 'String' && !model.options.hidden && !model.options.enum && otherDetails && otherDetails.isSelectable && otherDetails.selectData) {
    // console.log('kkk', otherDetails.selectData)
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: (data ? data[model.field] : ''),
      })(<Select style={{ marginRight: 8 }} disabled={otherDetails && otherDetails.isFromSetting}
        placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
        {otherDetails.selectData.map(doc => <Select.Option key={doc._id} value={doc._id}
          label={doc.name}>{doc.name}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  // if (model.type === 'String' && !model.options.hidden && !model.options.enum && otherDetails && otherDetails.valueType) {
  //   console.log(name, otherDetails.valueType)
  //   return <Form.Item key={key}
  //                     label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
  //     {getFieldDecorator(`${name}`, {
  //       rules: [{
  //         required: model.required,
  //         message: `${model.options.label ? model.options.label : model.field} is required!`
  //       }],
  //       initialValue: (data ? data[model.field] : ''),
  //     })(<Input style={{marginRight: 8}}
  //               type={otherDetails.valueType === 'Number' ? 'number' : otherDetails.valueType === 'Boolean' ? 'checkbox' : 'text'}
  //               placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
  //               autoComplete={'off'}/>)
  //     }
  //   </Form.Item>;
  // }

  if (model.type === 'String' && !model.options.hidden && !model.options.enum) {
    // console.log(model.field, otherDetails.valueType)
    const props = {
      rules: [{
        required: model.required,
        message: `${model.options.label ? model.options.label : model.field} is required!`
      }],
      initialValue: (data ? data[model.field] : ''),
    }
    if (otherDetails && otherDetails.valueType && otherDetails.valueType === 'Boolean') {
      props['valuePropName'] = 'checked';
      props['initialValue'] = data && data[model.field] === 'true' ? true : false;
    }
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${name}`, props)(
        otherDetails && otherDetails.valueType && otherDetails.valueType === 'Boolean'
          ?
          <Checkbox>Yes/No</Checkbox>
          : otherDetails && otherDetails.valueType && otherDetails.valueType === 'Number' ?
            <InputNumber style={{ marginRight: 8 }}
              placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
              autoComplete={'off'} />
            :
            <Input style={{ marginRight: 8 }}
              placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
              autoComplete={'off'} />
      )
      }
    </Form.Item>;
  }

  if (model.type === 'Boolean' && !model.options.hidden) {
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        valuePropName: 'checked',
        initialValue: (data ? data[model.field] : false),
      })(<Checkbox>{sanitizeFieldName(model.options.label ? model.options.label : model.field)}</Checkbox>)
      }
    </Form.Item>;
  }

  if (model.type === 'String' && !model.options.hidden && model.options.enum) {
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: data ? data[model.field] : '',
      })(<Select
        placeholder={`Please select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.options.enum.map(item => <Select.Option key={item}
          value={item}>{item}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  if (model.type === 'Date' && !model.options.hidden) {
    return <Form.Item key={key} label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: data && data[model.field] && moment(data[model.field]),
      })(<DatePicker />)
      }
    </Form.Item>;
  }

  if (model.type === 'Number' && !model.options.hidden) {
    // return <Form.Item key={key} label={sanitizeFieldName(model.options.label ? model.options.label : model.field)}>
    return <Form.Item key={key} label={
      <span>{sanitizeFieldName(model.options.label ? model.options.label : model.field)}&nbsp;
        {model.options.description ?
          (<Tooltip title={model.options.description}>
            <Icon type="question-circle-o" />
          </Tooltip>) : null}
      </span>
    }>

      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${model.options.label ? model.options.label : model.field} is required!`
        }],
        initialValue: (data ? data[model.field] : ''),
      })(<InputNumber min={0}
        placeholder={sanitizeFieldName(model.options.label ? model.options.label : model.field)}
        style={{ marginRight: 8 }}
        //onWheel={() => document.activeElement.blur()}
        // onWheel={event => event.currentTarget.blur()}
        onChange={otherDetails.onChange ? (e) => otherDetails.onChange(e) : null}
        autoComplete={'off'}
      />)
      } {model.options.description ?
        model.options.description.includes('%') ? <span>%</span> : null : null}

    </Form.Item>;
  }

  if (model.type === 'Array' && model.field !== 'documents' && model.options && model.options.ref) {
    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: (data && data.length) ? data.map(field => field._id) : [],
      })(<Select
        mode="multiple"
        placeholder={`Please ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {model.data.data.map(item => <Select.Option key={item._id}
          value={item._id}>{item.role}</Select.Option>)}
      </Select>)
      }
    </Form.Item>;
  }

  if (model.type === 'ObjectID' && model.field !== '_id' && model.field !== 'complaint' && !model.options.hidden) {

    return <Form.Item key={key}
      label={key === `00` ? sanitizeFieldName(model.options.label ? model.options.label : model.field) : ''}>
      {getFieldDecorator(`${name}`, {
        rules: [{
          required: model.required,
          message: `${sanitizeFieldName(model.options.label ? model.options.label : model.field)} is required!`
        }],
        initialValue: data && data[model.field] && data[model.field]._id,
      })(<Select
        showSearch
        allowClear
        mode="single"
        onChange={otherDetails.onChange ? (e) => otherDetails.onChange(e, (model.data && model.data.data)) : null}
        style={model.options.master ? { width: '80%', marginTop: '-10px' } : { width: '100%' }}
        filterOption={(input, option) =>
          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
        }
        placeholder={`Please Select ${sanitizeFieldName(model.options.label ? model.options.label : model.field)}`}
      >
        {
          otherDetails && otherDetails.availableMeters ? otherDetails.availableMeters.map(item => <Select.Option key={item._id}
            value={item._id}>{item.name}</Select.Option>) :
            model.data && model.data.data && model.data.data.map(item => <Select.Option key={item._id}
              value={item._id}>{item.name}</Select.Option>)
        }

      </Select>)
      }
      {
        model.options.master ? <MasterModal superMaster={(otherDetails && otherDetails.superMaster) || false}
          subMaster={(otherDetails && otherDetails.subMaster) || false}
          resource={(otherDetails && otherDetails.resource)}
          item={model.options.ref}
          title={'CREATE'} /> : ''
      }
    </Form.Item>;
  }
};

export const isArray = (a) => {
  return (!!a) && (a.constructor === Array);
};

/**
 * ⚠️  DEPRECATED: Favicon is now locked to AssetPro branding and cannot be overridden.
 * This function is kept for backward compatibility but does nothing.
 * The favicon is protected by the protection script in index.html
 * @param {Object} authUser - Auth user object (ignored)
 */
export const faviconDynamicFunction = (authUser) => {
  // DISABLED: Custom favicon override is no longer allowed
  // The AssetPro favicon is locked and protected against any changes
  // This function is kept for backward compatibility with existing code
  if (process.env.NODE_ENV === 'development') {
    console.log('ℹ️  Favicon override attempt blocked - AssetPro branding is protected');
  }
  // Do nothing - favicon is locked to HTML favicon
}

export function getErrorMessage(error) {
  let message;

  // Handle axios error responses (most common case)
  if (error && error.response && error.response.data && error.response.data.message) {
    message = error.response.data.message;
  }
  // Handle Error instances
  else if (error instanceof Error) {
    message = error.message;
  }
  // Handle objects with message property
  else if (error && typeof error === "object" && "message" in error) {
    message = String(error.message);
  }
  // Handle strings
  else if (typeof error === "string") {
    message = error;
  }
  // Fallback
  else {
    message = "Something went wrong!";
  }

  return message;
}


export const geojsonIndia = {
  "type": "FeatureCollection",
  "features": [
    { "type": "Feature", "properties": {}, "geometry": { "type": "LineString", "coordinates": [[68.205, 23.782], [68.199, 23.848], [68.211, 23.878], [68.28, 23.931], [68.331, 23.927], [68.343, 23.969], [68.367, 23.991], [68.394, 23.966], [68.753, 23.972], [68.764, 24.296], [68.808, 24.314], [68.829, 24.315], [68.866, 24.212], [68.907, 24.28], [68.945, 24.302], [68.985, 24.228], [69.003, 24.223], [69.095, 24.274], [69.194, 24.236], [69.313, 24.282], [69.493, 24.268], [69.594, 24.292], [69.731, 24.171], [70.025, 24.171], [70.067, 24.199], [70.11, 24.295], [70.327, 24.352], [70.368, 24.351], [70.561, 24.421], [70.602, 24.408], [70.562, 24.354], [70.585, 24.29], [70.571, 24.252], [70.714, 24.216], [70.805, 24.221], [70.907, 24.259], [70.874, 24.295], [70.947, 24.349], [70.986, 24.365], [71.042, 24.351], [71.084, 24.395], [71.12, 24.402], [71.126, 24.42], [71.103, 24.436], [70.999, 24.444], [71.005, 24.523], [70.987, 24.544], [70.986, 24.596], [71.009, 24.635], [71.075, 24.662], [71.096, 24.689], [71.065, 24.718], [71.026, 24.809], [70.938, 24.939], [70.889, 25.148], [70.752, 25.278], [70.737, 25.333], [70.665, 25.397], [70.678, 25.525], [70.667, 25.531], [70.674, 25.676], [70.66, 25.702], [70.609, 25.715], [70.53, 25.683], [70.387, 25.674], [70.269, 25.714], [70.247, 25.762], [70.174, 25.828], [70.1, 25.938], [70.083, 26.083], [70.141, 26.156], [70.175, 26.252], [70.163, 26.295], [70.185, 26.374], [70.174, 26.551], [70.117, 26.587], [70.056, 26.601], [69.887, 26.579], [69.823, 26.589], [69.72, 26.655], [69.51, 26.744], [69.484, 26.805], [69.513, 27.01], [69.586, 27.183], [69.862, 27.402], [69.934, 27.498], [70.026, 27.563], [70.132, 27.806], [70.227, 27.901], [70.296, 27.936], [70.372, 28.012], [70.506, 28.037], [70.59, 28.01], [70.677, 27.922], [70.684, 27.828], [70.74, 27.742], [70.759, 27.721], [70.872, 27.706], [70.963, 27.729], [71.206, 27.835], [71.383, 27.873], [71.666, 27.878], [71.898, 27.961], [71.927, 28.122], [72.004, 28.219], [72.132, 28.313], [72.206, 28.394], [72.299, 28.67], [72.391, 28.77], [72.733, 28.948], [72.946, 29.028], [73.004, 29.153], [73.084, 29.236], [73.282, 29.572], [73.397, 29.946], [73.597, 30.019], [73.807, 30.068], [73.972, 30.198], [73.957, 30.276], [73.931, 30.32], [73.88, 30.36], [73.974, 30.444], [73.926, 30.439], [73.934, 30.49], [73.964, 30.456], [73.964, 30.485], [73.982, 30.504], [74.02, 30.514], [74.012, 30.534], [74.031, 30.527], [74.039, 30.543], [74.057, 30.519], [74.072, 30.523], [74.091, 30.549], [74.073, 30.555], [74.102, 30.579], [74.096, 30.612], [74.118, 30.608], [74.127, 30.635], [74.148, 30.631], [74.193, 30.665], [74.233, 30.725], [74.287, 30.736], [74.261, 30.775], [74.302, 30.779], [74.295, 30.794], [74.32, 30.847], [74.382, 30.86], [74.361, 30.874], [74.366, 30.893], [74.423, 30.908], [74.41, 30.924], [74.429, 30.931], [74.414, 30.93], [74.416, 30.94], [74.546, 30.992], [74.543, 31.017], [74.568, 31.055], [74.597, 31.038], [74.671, 31.054], [74.696, 31.074], [74.689, 31.128], [74.659, 31.134], [74.636, 31.118], [74.631, 31.133], [74.603, 31.134], [74.611, 31.099], [74.571, 31.081], [74.552, 31.086], [74.548, 31.122], [74.51, 31.132], [74.526, 31.212], [74.517, 31.228], [74.533, 31.25], [74.521, 31.272], [74.542, 31.304], [74.526, 31.312], [74.549, 31.335], [74.552, 31.364], [74.584, 31.379], [74.601, 31.42], [74.655, 31.426], [74.639, 31.444], [74.651, 31.459], [74.627, 31.477], [74.636, 31.485], [74.609, 31.5], [74.587, 31.496], [74.578, 31.498], [74.575, 31.501], [74.584, 31.521], [74.613, 31.527], [74.616, 31.569], [74.555, 31.608], [74.535, 31.678], [74.487, 31.715], [74.504, 31.741], [74.559, 31.758], [74.558, 31.805], [74.607, 31.869], [74.608, 31.89], [74.636, 31.884], [74.667, 31.923], [74.719, 31.924], [74.721, 31.942], [74.757, 31.944], [74.756, 31.956], [74.819, 31.959], [74.829, 31.999], [74.88, 32.032], [74.869, 32.042], [74.879, 32.054], [74.928, 32.066], [75.012, 32.036], [75.069, 32.067], [75.105, 32.059], [75.123, 32.081], [75.174, 32.068], [75.198, 32.083], [75.203, 32.12], [75.24, 32.091], [75.279, 32.118], [75.283, 32.148], [75.322, 32.179], [75.316, 32.208], [75.372, 32.225], [75.382, 32.269], [75.32, 32.297], [75.338, 32.321], [75.323, 32.343], [75.288, 32.355], [75.285, 32.372], [75.258, 32.371], [75.256, 32.389], [75.194, 32.401], [75.19, 32.426], [75.131, 32.409], [75.101, 32.478], [75.085, 32.469], [75.028, 32.497], [75.019, 32.466], [74.951, 32.447], [74.938, 32.471], [74.897, 32.468], [74.877, 32.493], [74.819, 32.498], [74.795, 32.476], [74.688, 32.487], [74.691, 32.533], [74.663, 32.544], [74.674, 32.568], [74.653, 32.563], [74.659, 32.597], [74.639, 32.615], [74.695, 32.661], [74.653, 32.697], [74.705, 32.842], [74.641, 32.819], [74.635, 32.807], [74.658, 32.788], [74.632, 32.776], [74.634, 32.749], [74.619, 32.761], [74.577, 32.748], [74.563, 32.76], [74.512, 32.745], [74.512, 32.764], [74.486, 32.764], [74.459, 32.788], [74.415, 32.785], [74.391, 32.763], [74.355, 32.767], [74.314, 32.797], [74.303, 32.83], [74.22, 32.849], [74.211, 32.873], [74.179, 32.889], [74.069, 32.91], [74.058, 32.934], [74.0, 32.935], [74.006, 32.955], [73.972, 32.967], [73.965, 32.987], [73.826, 33.004], [73.826, 32.977], [73.79, 32.967], [73.794, 33.004], [73.749, 33.034], [73.743, 33.066], [73.685, 33.087], [73.638, 33.085], [73.631, 33.139], [73.649, 33.138], [73.665, 33.161], [73.668, 33.202], [73.648, 33.223], [73.633, 33.208], [73.638, 33.23], [73.606, 33.274], [73.614, 33.293], [73.589, 33.324], [73.598, 33.337], [73.578, 33.329], [73.57, 33.343], [73.584, 33.356], [73.565, 33.366], [73.603, 33.419], [73.587, 33.423], [73.596, 33.439], [73.632, 33.448], [73.602, 33.497], [73.619, 33.495], [73.611, 33.513], [73.642, 33.529], [73.624, 33.541], [73.629, 33.571], [73.605, 33.589], [73.612, 33.604], [73.567, 33.618], [73.578, 33.638], [73.567, 33.669], [73.603, 33.715], [73.595, 33.751], [73.56, 33.781], [73.594, 33.89], [73.548, 33.937], [73.516, 33.999], [73.491, 34.14], [73.499, 34.211], [73.473, 34.252], [73.481, 34.289], [73.457, 34.276], [73.43, 34.346], [73.396, 34.372], [73.428, 34.426], [73.431, 34.521], [73.454, 34.571], [73.532, 34.571], [73.556, 34.59], [73.611, 34.585], [73.65, 34.562], [73.654, 34.6], [73.695, 34.65], [73.659, 34.673], [73.73, 34.772], [73.772, 34.796], [73.822, 34.792], [73.838, 34.813], [73.919, 34.812], [73.93, 34.832], [73.961, 34.839], [73.967, 34.864], [74.03, 34.876], [74.037, 34.919], [74.071, 34.935], [74.059, 34.993], [74.11, 35.016], [74.067, 35.046], [74.071, 35.059], [74.101, 35.099], [74.134, 35.11], [74.106, 35.126], [74.112, 35.148], [74.034, 35.147], [74.003, 35.184], [73.957, 35.168], [73.924, 35.204], [73.861, 35.207], [73.808, 35.239], [73.77, 35.236], [73.734, 35.209], [73.708, 35.222], [73.725, 35.273], [73.695, 35.318], [73.695, 35.369], [73.727, 35.419], [73.792, 35.454], [73.778, 35.523], [73.73, 35.529], [73.721, 35.549], [73.659, 35.548], [73.628, 35.569], [73.562, 35.546], [73.528, 35.567], [73.501, 35.558], [73.477, 35.572], [73.398, 35.557], [73.364, 35.597], [73.269, 35.624], [73.133, 35.711], [73.126, 35.776], [73.149, 35.831], [73.084, 35.877], [73.029, 35.847], [72.987, 35.86], [72.918, 35.839], [72.892, 35.844], [72.891, 35.874], [72.839, 35.867], [72.819, 35.882], [72.784, 35.842], [72.761, 35.832], [72.727, 35.853], [72.684, 35.822], [72.628, 35.858], [72.585, 35.859], [72.558, 35.898], [72.519, 35.906], [72.513, 35.936], [72.535, 35.951], [72.539, 35.986], [72.56, 35.987], [72.584, 36.017], [72.569, 36.045], [72.536, 36.047], [72.517, 36.067], [72.528, 36.11], [72.562, 36.14], [72.536, 36.175], [72.581, 36.253], [72.619, 36.269], [72.685, 36.244], [72.681, 36.271], [72.759, 36.299], [72.816, 36.356], [72.854, 36.366], [72.876, 36.395], [72.86, 36.436], [72.908, 36.461], [72.979, 36.457], [72.978, 36.511], [73.052, 36.533], [73.097, 36.606], [73.074, 36.629], [73.068, 36.701], [73.116, 36.684], [73.171, 36.724], [73.201, 36.696], [73.238, 36.712], [73.294, 36.704], [73.348, 36.716], [73.352, 36.735], [73.421, 36.743], [73.498, 36.713], [73.579, 36.722], [73.593, 36.693], [73.683, 36.687], [73.71, 36.712], [73.775, 36.702], [73.796, 36.719], [73.872, 36.701], [73.885, 36.73], [73.868, 36.766], [73.837, 36.795], [73.802, 36.794], [73.798, 36.818], [73.759, 36.816], [73.706, 36.838], [73.706, 36.858], [73.667, 36.881], [73.671, 36.912], [73.729, 36.898], [73.751, 36.91], [73.801, 36.888], [73.82, 36.903], [73.859, 36.897], [73.893, 36.876], [73.915, 36.883], [73.962, 36.839], [74.046, 36.811], [74.085, 36.842], [74.133, 36.848], [74.156, 36.91], [74.249, 36.894], [74.42, 36.995], [74.52, 36.996], [74.54, 36.963], [74.564, 36.958], [74.58, 37.021], [74.568, 37.052], [74.681, 37.087], [74.707, 37.087], [74.747, 37.02], [74.769, 37.041], [74.839, 37.036], [74.838, 36.998], [74.91, 36.916], [75.016, 36.993], [75.076, 36.961], [75.107, 36.963], [75.174, 37.001], [75.22, 37.052], [75.343, 37.068], [75.36, 37.039], [75.352, 36.991], [75.367, 36.975], [75.414, 36.977], [75.406, 36.908], [75.441, 36.898], [75.462, 36.83], [75.607, 36.779], [75.731, 36.623], [75.789, 36.578], [75.928, 36.521], [76.084, 36.484], [76.178, 36.398], [76.251, 36.357], [76.355, 36.368], [76.407, 36.327], [76.436, 36.322], [76.454, 36.276], [76.438, 36.262], [76.479, 36.223], [76.555, 36.198], [76.568, 36.178], [76.616, 36.173], [76.647, 36.191], [76.711, 36.135], [76.728, 36.087], [76.81, 36.053], [76.814, 36.027], [76.731, 35.96], [76.814, 35.849], [76.855, 35.84], [76.921, 35.793], [77.002, 35.776], [77.094, 35.8], [77.135, 35.794], [77.149, 35.77], [77.173, 35.765], [77.177, 35.735], [77.227, 35.728], [77.236, 35.71], [77.284, 35.72], [77.319, 35.697], [77.335, 35.72], [77.368, 35.717], [77.403, 35.662], [77.438, 35.655], [77.434, 35.609], [77.465, 35.594], [77.462, 35.548], [77.484, 35.534], [77.435, 35.516], [77.388, 35.55], [77.321, 35.534], [77.391, 35.472], [77.449, 35.461], [77.526, 35.484], [77.626, 35.466], [77.649, 35.486], [77.672, 35.468], [77.72, 35.474], [77.737, 35.524], [77.778, 35.494], [77.822, 35.514], [77.907, 35.467], [77.929, 35.495], [77.983, 35.456], [77.964, 35.498], [77.935, 35.516], [77.971, 35.566], [77.96, 35.604], [77.999, 35.586], [78.046, 35.587], [78.085, 35.553], [78.147, 35.54], [78.173, 35.599], [78.168, 35.628], [78.197, 35.625], [78.21, 35.663], [78.258, 35.642], [78.283, 35.66], [78.278, 35.716], [78.4, 35.731], [78.435, 35.778], [78.527, 35.757], [78.647, 35.818], [78.675, 35.852], [78.781, 35.864], [78.827, 35.848], [78.968, 35.884], [79.054, 35.841], [79.156, 35.832], [79.22, 35.889], [79.203, 35.925], [79.213, 35.954], [79.262, 35.984], [79.407, 35.986], [79.435, 35.893], [79.536, 35.874], [79.748, 35.792], [79.892, 35.772], [79.951, 35.819], [80.008, 35.828], [80.056, 35.783], [80.123, 35.664], [80.237, 35.632], [80.307, 35.59], [80.342, 35.462], [80.291, 35.428], [80.292, 35.359], [80.268, 35.295], [80.23, 35.2], [80.186, 35.148], [80.187, 35.012], [80.114, 34.858], [80.074, 34.825], [80.063, 34.707], [79.949, 34.666], [79.864, 34.676], [79.775, 34.611], [79.792, 34.573], [79.765, 34.562], [79.76, 34.538], [79.817, 34.507], [79.813, 34.481], [79.788, 34.466], [79.663, 34.468], [79.597, 34.486], [79.514, 34.46], [79.53, 34.406], [79.568, 34.395], [79.565, 34.318], [79.596, 34.264], [79.569, 34.206], [79.498, 34.188], [79.49, 34.12], [79.421, 34.078], [79.414, 34.047], [79.44, 34.023], [79.434, 34.013], [79.144, 34.058], [79.134, 34.018], [79.077, 34.014], [79.011, 34.044], [78.912, 34.01], [78.891, 33.974], [78.962, 33.875], [79.005, 33.772], [79.057, 33.758], [79.028, 33.749], [79.014, 33.685], [79.067, 33.664], [79.094, 33.634], [79.087, 33.617], [79.007, 33.608], [78.908, 33.62], [78.888, 33.574], [78.914, 33.562], [78.944, 33.512], [78.928, 33.439], [78.956, 33.353], [78.981, 33.328], [79.085, 33.289], [79.234, 33.289], [79.437, 33.252], [79.427, 33.186], [79.362, 33.093], [79.376, 33.034], [79.315, 33.007], [79.433, 32.925], [79.541, 32.783], [79.582, 32.772], [79.605, 32.733], [79.478, 32.589], [79.446, 32.572], [79.424, 32.527], [79.376, 32.532], [79.369, 32.568], [79.304, 32.592], [79.262, 32.534], [79.23, 32.528], [79.185, 32.479], [79.115, 32.47], [79.129, 32.427], [79.105, 32.41], [79.097, 32.376], [79.012, 32.383], [78.963, 32.337], [78.937, 32.371], [78.838, 32.439], [78.806, 32.443], [78.758, 32.554], [78.78, 32.604], [78.74, 32.656], [78.75, 32.698], [78.703, 32.66], [78.647, 32.654], [78.604, 32.6], [78.559, 32.62], [78.516, 32.61], [78.49, 32.585], [78.454, 32.585], [78.397, 32.526], [78.453, 32.504], [78.466, 32.481], [78.453, 32.456], [78.489, 32.42], [78.532, 32.416], [78.48, 32.346], [78.481, 32.28], [78.452, 32.239], [78.571, 32.242], [78.61, 32.205], [78.591, 32.151], [78.615, 32.111], [78.655, 32.109], [78.743, 32.005], [78.778, 31.994], [78.768, 31.931], [78.74, 31.886], [78.743, 31.838], [78.704, 31.811], [78.705, 31.776], [78.751, 31.682], [78.797, 31.683], [78.803, 31.646], [78.846, 31.608], [78.774, 31.546], [78.732, 31.535], [78.721, 31.507], [78.725, 31.484], [78.763, 31.485], [78.81, 31.448], [78.79, 31.396], [78.848, 31.367], [78.843, 31.325], [78.872, 31.308], [78.894, 31.265], [78.928, 31.256], [78.939, 31.326], [79.011, 31.357], [79.062, 31.461], [79.127, 31.435], [79.199, 31.357], [79.246, 31.33], [79.239, 31.314], [79.272, 31.283], [79.252, 31.243], [79.293, 31.221], [79.317, 31.137], [79.399, 31.108], [79.408, 31.077], [79.425, 31.071], [79.425, 31.03], [79.519, 31.027], [79.556, 30.961], [79.599, 30.938], [79.671, 30.979], [79.703, 30.973], [79.757, 30.998], [79.864, 30.97], [79.929, 30.882], [79.962, 30.89], [80.042, 30.836], [80.056, 30.841], [80.111, 30.779], [80.178, 30.804], [80.215, 30.749], [80.24, 30.762], [80.251, 30.737], [80.236, 30.69], [80.2, 30.683], [80.197, 30.662], [80.221, 30.642], [80.212, 30.622], [80.227, 30.579], [80.258, 30.559], [80.283, 30.572], [80.386, 30.515], [80.416, 30.525], [80.539, 30.449], [80.598, 30.479], [80.752, 30.393], [80.822, 30.316], [81.033, 30.246], [81.026, 30.227], [81.044, 30.206], [80.96, 30.179], [80.918, 30.19], [80.92, 30.214], [80.903, 30.215], [80.868, 30.174], [80.874, 30.126], [80.761, 30.049], [80.747, 30.006], [80.719, 30.001], [80.674, 29.957], [80.602, 29.958], [80.574, 29.924], [80.553, 29.851], [80.506, 29.823], [80.494, 29.796], [80.435, 29.806], [80.407, 29.795], [80.397, 29.759], [80.366, 29.749], [80.384, 29.675], [80.42, 29.638], [80.408, 29.596], [80.379, 29.561], [80.343, 29.553], [80.358, 29.533], [80.35, 29.519], [80.287, 29.477], [80.302, 29.453], [80.242, 29.443], [80.242, 29.412], [80.275, 29.393], [80.28, 29.347], [80.317, 29.315], [80.291, 29.232], [80.297, 29.205], [80.286, 29.196], [80.249, 29.221], [80.24, 29.203], [80.272, 29.141], [80.233, 29.119], [80.183, 29.137], [80.143, 29.099], [80.124, 29.013], [80.135, 29.007], [80.118, 28.982], [80.1, 28.987], [80.058, 28.917], [80.075, 28.825], [80.118, 28.829], [80.216, 28.756], [80.257, 28.754], [80.257, 28.729], [80.317, 28.7], [80.326, 28.666], [80.361, 28.635], [80.451, 28.63], [80.469, 28.584], [80.518, 28.552], [80.531, 28.573], [80.503, 28.665], [80.54, 28.691], [80.569, 28.688], [80.591, 28.68], [80.589, 28.648], [80.668, 28.642], [80.677, 28.604], [80.696, 28.604], [80.69, 28.588], [80.715, 28.568], [80.769, 28.566], [80.789, 28.524], [80.866, 28.49], [80.862, 28.504], [80.896, 28.507], [80.915, 28.458], [80.914, 28.468], [80.93, 28.458], [80.943, 28.469], [80.932, 28.459], [80.952, 28.448], [80.98, 28.455], [80.965, 28.445], [80.979, 28.434], [81.017, 28.451], [81.013, 28.438], [81.034, 28.428], [81.017, 28.416], [81.034, 28.399], [81.036, 28.414], [81.08, 28.385], [81.211, 28.361], [81.234, 28.325], [81.233, 28.289], [81.321, 28.198], [81.321, 28.169], [81.302, 28.165], [81.328, 28.148], [81.318, 28.134], [81.371, 28.143], [81.374, 28.177], [81.447, 28.161], [81.45, 28.141], [81.484, 28.119], [81.478, 28.083], [81.624, 28.002], [81.698, 27.988], [81.885, 27.857], [81.926, 27.86], [81.968, 27.929], [82.07, 27.924], [82.121, 27.866], [82.208, 27.844], [82.449, 27.679], [82.708, 27.723], [82.712, 27.665], [82.737, 27.643], [82.735, 27.61], [82.756, 27.588], [82.736, 27.502], [82.929, 27.501], [82.954, 27.468], [83.035, 27.449], [83.188, 27.454], [83.272, 27.383], [83.272, 27.353], [83.318, 27.33], [83.359, 27.343], [83.409, 27.413], [83.384, 27.436], [83.402, 27.457], [83.388, 27.48], [83.614, 27.469], [83.864, 27.347], [83.883, 27.378], [83.833, 27.426], [83.847, 27.446], [83.878, 27.436], [83.997, 27.446], [84.027, 27.433], [84.095, 27.489], [84.098, 27.517], [84.146, 27.519], [84.149, 27.486], [84.206, 27.47], [84.209, 27.443], [84.254, 27.454], [84.292, 27.385], [84.622, 27.337], [84.691, 27.215], [84.674, 27.096], [84.646, 27.076], [84.643, 27.046], [84.757, 27.003], [84.774, 27.018], [84.794, 26.996], [84.825, 27.021], [84.892, 26.97], [84.963, 26.96], [84.978, 26.94], [84.968, 26.916], [85.061, 26.887], [85.031, 26.874], [85.024, 26.854], [85.191, 26.87], [85.177, 26.81], [85.211, 26.758], [85.335, 26.742], [85.408, 26.791], [85.452, 26.781], [85.479, 26.802], [85.496, 26.797], [85.498, 26.812], [85.566, 26.841], [85.576, 26.861], [85.586, 26.847], [85.624, 26.874], [85.721, 26.82], [85.734, 26.796], [85.732, 26.654], [85.802, 26.624], [85.818, 26.603], [85.851, 26.609], [85.851, 26.569], [85.929, 26.617], [85.948, 26.614], [85.96, 26.651], [86.028, 26.667], [86.139, 26.629], [86.136, 26.606], [86.193, 26.614], [86.196, 26.594], [86.218, 26.588], [86.252, 26.617], [86.333, 26.619], [86.499, 26.542], [86.541, 26.539], [86.57, 26.497], [86.693, 26.451], [86.731, 26.423], [86.766, 26.459], [86.834, 26.439], [86.894, 26.462], [86.892, 26.486], [86.93, 26.49], [86.932, 26.517], [87.015, 26.532], [87.045, 26.587], [87.072, 26.586], [87.092, 26.45], [87.163, 26.404], [87.261, 26.409], [87.266, 26.374], [87.312, 26.372], [87.341, 26.348], [87.358, 26.361], [87.369, 26.408], [87.466, 26.44], [87.548, 26.418], [87.605, 26.381], [87.652, 26.393], [87.65, 26.406], [87.678, 26.416], [87.678, 26.436], [87.734, 26.408], [87.765, 26.41], [87.79, 26.469], [87.849, 26.436], [87.888, 26.487], [87.91, 26.458], [87.899, 26.449], [87.924, 26.447], [87.927, 26.418], [87.992, 26.393], [88.007, 26.361], [88.031, 26.365], [88.035, 26.392], [88.096, 26.439], [88.092, 26.463], [88.107, 26.476], [88.09, 26.507], [88.098, 26.538], [88.16, 26.636], [88.187, 26.748], [88.174, 26.865], [88.136, 26.898], [88.145, 26.922], [88.12, 26.951], [88.135, 26.986], [88.092, 27.005], [88.078, 27.035], [88.038, 27.036], [88.021, 27.088], [87.987, 27.119], [88.019, 27.171], [88.013, 27.216], [88.032, 27.286], [88.067, 27.336], [88.042, 27.373], [88.051, 27.413], [88.075, 27.433], [88.044, 27.496], [88.082, 27.584], [88.145, 27.665], [88.156, 27.736], [88.179, 27.746], [88.197, 27.791], [88.174, 27.82], [88.202, 27.837], [88.197, 27.854], [88.133, 27.882], [88.12, 27.916], [88.146, 27.964], [88.207, 27.941], [88.21, 27.962], [88.237, 27.971], [88.25, 27.941], [88.347, 27.989], [88.397, 27.978], [88.414, 28.0], [88.468, 28.017], [88.495, 28.054], [88.548, 28.036], [88.551, 28.082], [88.618, 28.1], [88.609, 28.129], [88.632, 28.122], [88.67, 28.074], [88.757, 28.078], [88.837, 28.018], [88.836, 27.929], [88.867, 27.92], [88.887, 27.857], [88.88, 27.83], [88.856, 27.816], [88.854, 27.756], [88.868, 27.742], [88.839, 27.705], [88.852, 27.672], [88.814, 27.64], [88.793, 27.575], [88.766, 27.566], [88.794, 27.525], [88.777, 27.468], [88.809, 27.424], [88.806, 27.407], [88.838, 27.378], [88.861, 27.387], [88.882, 27.344], [88.919, 27.321], [88.904, 27.273], [88.803, 27.248], [88.788, 27.184], [88.765, 27.177], [88.746, 27.144], [88.802, 27.14], [88.87, 27.11], [88.877, 26.944], [88.922, 26.994], [88.953, 26.968], [88.944, 26.934], [88.98, 26.917], [89.022, 26.941], [89.051, 26.916], [89.049, 26.899], [89.096, 26.892], [89.101, 26.843], [89.135, 26.808], [89.262, 26.814], [89.319, 26.851], [89.379, 26.862], [89.39, 26.842], [89.439, 26.841], [89.469, 26.803], [89.56, 26.813], [89.566, 26.799], [89.651, 26.776], [89.644, 26.748], [89.617, 26.729], [89.624, 26.718], [89.66, 26.72], [89.672, 26.74], [89.724, 26.722], [89.753, 26.735], [89.771, 26.701], [89.863, 26.701], [89.863, 26.737], [89.897, 26.724], [90.05, 26.73], [90.195, 26.773], [90.188, 26.807], [90.225, 26.855], [90.3, 26.848], [90.348, 26.875], [90.357, 26.901], [90.418, 26.904], [90.547, 26.817], [90.634, 26.794], [90.647, 26.777], [90.676, 26.784], [90.717, 26.768], [90.992, 26.791], [91.054, 26.781], [91.098, 26.822], [91.237, 26.812], [91.337, 26.781], [91.376, 26.795], [91.408, 26.84], [91.495, 26.791], [91.626, 26.821], [91.69, 26.806], [91.824, 26.864], [91.859, 26.913], [91.892, 26.919], [91.984, 26.858], [92.057, 26.847], [92.103, 26.867], [92.121, 26.96], [92.103, 27.004], [92.078, 27.017], [92.082, 27.041], [92.044, 27.051], [92.031, 27.08], [92.027, 27.168], [92.058, 27.19], [92.073, 27.233], [92.038, 27.257], [92.074, 27.279], [92.12, 27.272], [92.123, 27.287], [92.065, 27.327], [92.048, 27.363], [92.058, 27.4], [92.016, 27.481], [91.953, 27.46], [91.849, 27.486], [91.825, 27.468], [91.767, 27.465], [91.715, 27.474], [91.695, 27.505], [91.653, 27.483], [91.612, 27.544], [91.583, 27.556], [91.566, 27.584], [91.584, 27.608], [91.562, 27.631], [91.573, 27.661], [91.629, 27.699], [91.645, 27.769], [91.615, 27.822], [91.567, 27.817], [91.556, 27.856], [91.668, 27.853], [91.699, 27.815], [91.734, 27.8], [91.824, 27.808], [91.875, 27.723], [91.924, 27.717], [91.99, 27.769], [92.049, 27.758], [92.151, 27.832], [92.246, 27.868], [92.278, 27.853], [92.31, 27.778], [92.382, 27.795], [92.389, 27.815], [92.456, 27.809], [92.5, 27.846], [92.556, 27.817], [92.617, 27.888], [92.668, 27.902], [92.738, 27.988], [92.709, 28.04], [92.663, 28.068], [92.687, 28.129], [92.814, 28.21], [92.834, 28.176], [92.964, 28.261], [93.0, 28.236], [93.03, 28.269], [93.029, 28.31], [93.095, 28.308], [93.131, 28.33], [93.222, 28.328], [93.229, 28.406], [93.185, 28.442], [93.28, 28.507], [93.308, 28.57], [93.303, 28.593], [93.331, 28.608], [93.339, 28.638], [93.42, 28.653], [93.451, 28.674], [93.476, 28.652], [93.495, 28.683], [93.53, 28.659], [93.576, 28.655], [93.642, 28.657], [93.734, 28.686], [93.777, 28.666], [93.844, 28.707], [93.93, 28.67], [93.963, 28.712], [93.97, 28.75], [93.996, 28.772], [93.986, 28.805], [93.996, 28.843], [94.028, 28.854], [94.151, 28.959], [94.218, 29.082], [94.296, 29.147], [94.366, 29.156], [94.381, 29.191], [94.433, 29.226], [94.548, 29.222], [94.634, 29.346], [94.688, 29.324], [94.751, 29.27], [94.799, 29.216], [94.805, 29.167], [94.908, 29.178], [94.919, 29.159], [94.964, 29.16], [95.024, 29.131], [94.99, 29.172], [95.095, 29.142], [95.124, 29.115], [95.248, 29.108], [95.247, 29.07], [95.262, 29.053], [95.299, 29.06], [95.447, 29.031], [95.488, 29.081], [95.494, 29.14], [95.542, 29.129], [95.534, 29.212], [95.585, 29.215], [95.593, 29.257], [95.632, 29.247], [95.698, 29.301], [95.73, 29.308], [95.779, 29.358], [95.798, 29.339], [95.843, 29.355], [95.873, 29.393], [95.955, 29.384], [96.048, 29.454], [96.085, 29.459], [96.152, 29.396], [96.182, 29.349], [96.186, 29.305], [96.227, 29.246], [96.301, 29.242], [96.373, 29.284], [96.395, 29.247], [96.351, 29.172], [96.244, 29.152], [96.185, 29.089], [96.122, 29.071], [96.177, 28.992], [96.178, 28.963], [96.151, 28.953], [96.143, 28.929], [96.166, 28.892], [96.236, 28.927], [96.283, 28.982], [96.346, 29.021], [96.442, 29.03], [96.522, 29.067], [96.473, 28.977], [96.488, 28.952], [96.52, 28.956], [96.533, 28.875], [96.614, 28.767], [96.586, 28.709], [96.467, 28.671], [96.482, 28.619], [96.398, 28.57], [96.394, 28.547], [96.341, 28.54], [96.319, 28.519], [96.357, 28.469], [96.252, 28.394], [96.289, 28.389], [96.302, 28.369], [96.362, 28.374], [96.395, 28.327], [96.416, 28.333], [96.422, 28.37], [96.457, 28.406], [96.5, 28.402], [96.57, 28.446], [96.65, 28.45], [96.739, 28.41], [96.77, 28.361], [96.837, 28.357], [96.888, 28.378], [96.918, 28.343], [96.992, 28.304], [97.092, 28.352], [97.138, 28.333], [97.173, 28.286], [97.217, 28.29], [97.248, 28.266], [97.286, 28.267], [97.378, 28.217], [97.396, 28.185], [97.356, 28.187], [97.325, 28.148], [97.343, 28.114], [97.307, 28.074], [97.323, 28.057], [97.374, 28.063], [97.375, 28.035], [97.407, 28.019], [97.364, 27.968], [97.382, 27.893], [97.362, 27.874], [97.322, 27.889], [97.302, 27.916], [97.249, 27.899], [97.169, 27.815], [97.116, 27.785], [97.089, 27.734], [97.032, 27.748], [96.984, 27.666], [96.934, 27.66], [96.89, 27.607], [96.93, 27.515], [96.903, 27.453], [96.96, 27.404], [96.962, 27.373], [96.999, 27.319], [97.029, 27.307], [97.086, 27.238], [97.089, 27.212], [97.162, 27.14], [97.137, 27.09], [97.099, 27.107], [97.062, 27.09], [96.985, 27.154], [96.874, 27.18], [96.855, 27.21], [96.885, 27.226], [96.884, 27.26], [96.847, 27.271], [96.848, 27.29], [96.797, 27.346], [96.704, 27.372], [96.698, 27.358], [96.606, 27.366], [96.596, 27.333], [96.551, 27.318], [96.524, 27.286], [96.441, 27.306], [96.387, 27.284], [96.308, 27.294], [96.271, 27.271], [96.228, 27.279], [96.023, 27.18], [95.946, 27.052], [95.87, 27.013], [95.802, 27.015], [95.755, 26.954], [95.745, 26.898], [95.723, 26.881], [95.667, 26.903], [95.632, 26.874], [95.608, 26.813], [95.543, 26.836], [95.525, 26.823], [95.483, 26.746], [95.459, 26.742], [95.43, 26.7], [95.361, 26.671], [95.336, 26.674], [95.304, 26.651], [95.26, 26.655], [95.257, 26.676], [95.234, 26.683], [95.209, 26.649], [95.149, 26.616], [95.154, 26.583], [95.107, 26.541], [95.115, 26.518], [95.062, 26.45], [95.084, 26.447], [95.104, 26.421], [95.1, 26.394], [95.132, 26.378], [95.127, 26.254], [95.115, 26.233], [95.142, 26.212], [95.122, 26.185], [95.118, 26.102], [95.186, 26.073], [95.126, 25.986], [95.089, 25.95], [95.031, 25.931], [95.012, 25.898], [95.009, 25.867], [95.05, 25.8], [95.049, 25.759], [94.936, 25.668], [94.915, 25.608], [94.882, 25.591], [94.899, 25.565], [94.846, 25.562], [94.806, 25.492], [94.784, 25.48], [94.752, 25.494], [94.718, 25.469], [94.683, 25.466], [94.67, 25.418], [94.635, 25.396], [94.635, 25.357], [94.585, 25.267], [94.576, 25.214], [94.606, 25.181], [94.621, 25.187], [94.741, 25.126], [94.744, 25.037], [94.697, 24.968], [94.714, 24.934], [94.632, 24.839], [94.618, 24.785], [94.63, 24.758], [94.606, 24.712], [94.585, 24.705], [94.578, 24.724], [94.566, 24.706], [94.54, 24.707], [94.539, 24.643], [94.507, 24.594], [94.454, 24.565], [94.424, 24.483], [94.396, 24.483], [94.397, 24.409], [94.358, 24.393], [94.38, 24.377], [94.349, 24.336], [94.318, 24.33], [94.323, 24.279], [94.289, 24.234], [94.277, 24.169], [94.262, 24.164], [94.256, 24.087], [94.242, 24.057], [94.228, 24.06], [94.24, 24.039], [94.193, 23.936], [94.17, 23.929], [94.156, 23.848], [94.12, 23.836], [94.098, 23.886], [94.051, 23.887], [94.016, 23.925], [93.961, 23.928], [93.931, 23.95], [93.894, 23.953], [93.859, 23.932], [93.808, 23.927], [93.754, 24.005], [93.623, 24.011], [93.592, 23.961], [93.557, 23.982], [93.55, 23.959], [93.505, 23.942], [93.462, 23.976], [93.417, 24.071], [93.342, 24.102], [93.354, 24.091], [93.329, 24.081], [93.338, 24.061], [93.326, 24.046], [93.338, 24.04], [93.326, 24.029], [93.339, 24.021], [93.328, 23.985], [93.351, 23.942], [93.393, 23.929], [93.385, 23.848], [93.403, 23.805], [93.392, 23.756], [93.411, 23.729], [93.407, 23.707], [93.437, 23.687], [93.416, 23.648], [93.429, 23.589], [93.41, 23.564], [93.418, 23.539], [93.395, 23.504], [93.388, 23.421], [93.402, 23.384], [93.388, 23.359], [93.356, 23.353], [93.373, 23.33], [93.363, 23.279], [93.389, 23.217], [93.368, 23.144], [93.386, 23.134], [93.356, 23.116], [93.339, 23.074], [93.352, 23.07], [93.294, 23.007], [93.229, 23.011], [93.21, 23.048], [93.184, 23.059], [93.156, 23.043], [93.136, 23.061], [93.127, 23.044], [93.12, 23.002], [93.14, 22.99], [93.138, 22.951], [93.164, 22.911], [93.131, 22.906], [93.111, 22.818], [93.094, 22.806], [93.107, 22.75], [93.095, 22.673], [93.141, 22.592], [93.107, 22.527], [93.129, 22.523], [93.139, 22.454], [93.186, 22.427], [93.202, 22.263], [93.142, 22.245], [93.162, 22.197], [93.151, 22.176], [93.124, 22.174], [93.111, 22.204], [93.038, 22.195], [93.049, 22.169], [93.037, 22.144], [93.059, 22.101], [93.004, 22.103], [93.012, 22.088], [92.993, 22.039], [93.007, 21.982], [92.981, 21.98], [92.952, 22.03], [92.927, 22.015], [92.935, 22.006], [92.906, 21.941], [92.891, 22.012], [92.864, 22.027], [92.864, 22.063], [92.841, 22.059], [92.81, 22.096], [92.7, 22.155], [92.69, 22.072], [92.688, 22.104], [92.682, 22.104], [92.68, 22.012], [92.652, 22.016], [92.635, 21.983], [92.603, 21.978], [92.613, 21.99], [92.593, 22.037], [92.603, 22.061], [92.563, 22.128], [92.579, 22.143], [92.606, 22.123], [92.609, 22.164], [92.595, 22.175], [92.581, 22.322], [92.552, 22.409], [92.551, 22.513], [92.522, 22.559], [92.539, 22.589], [92.529, 22.665], [92.513, 22.733], [92.474, 22.746], [92.45, 22.894], [92.434, 22.886], [92.42, 22.918], [92.401, 22.912], [92.398, 22.93], [92.372, 22.936], [92.392, 23.056], [92.358, 23.103], [92.368, 23.127], [92.347, 23.236], [92.404, 23.241], [92.381, 23.285], [92.386, 23.306], [92.364, 23.323], [92.379, 23.362], [92.356, 23.372], [92.357, 23.411], [92.317, 23.472], [92.308, 23.578], [92.287, 23.596], [92.296, 23.622], [92.273, 23.642], [92.291, 23.681], [92.279, 23.716], [92.241, 23.721], [92.233, 23.668], [92.216, 23.652], [92.203, 23.706], [92.178, 23.708], [92.172, 23.739], [92.148, 23.736], [92.063, 23.645], [92.009, 23.663], [91.978, 23.733], [91.957, 23.734], [91.958, 23.694], [91.934, 23.685], [91.97, 23.478], [91.937, 23.467], [91.943, 23.435], [91.9, 23.441], [91.845, 23.405], [91.825, 23.352], [91.762, 23.303], [91.81, 23.165], [91.813, 23.099], [91.836, 23.093], [91.806, 23.063], [91.775, 23.07], [91.781, 23.029], [91.768, 23.041], [91.721, 22.988], [91.645, 22.985], [91.62, 22.938], [91.6, 22.954], [91.614, 22.958], [91.606, 22.972], [91.577, 22.965], [91.543, 23.0], [91.55, 23.038], [91.531, 23.038], [91.53, 23.092], [91.503, 23.131], [91.515, 23.145], [91.491, 23.158], [91.492, 23.178], [91.507, 23.184], [91.471, 23.196], [91.484, 23.209], [91.451, 23.219], [91.47, 23.228], [91.445, 23.247], [91.454, 23.26], [91.418, 23.255], [91.416, 23.283], [91.411, 23.256], [91.398, 23.265], [91.409, 23.248], [91.392, 23.246], [91.401, 23.229], [91.386, 23.228], [91.38, 23.184], [91.417, 23.064], [91.396, 23.056], [91.347, 23.102], [91.323, 23.158], [91.327, 23.252], [91.3, 23.292], [91.313, 23.306], [91.29, 23.319], [91.32, 23.36], [91.291, 23.351], [91.249, 23.49], [91.201, 23.52], [91.213, 23.55], [91.195, 23.547], [91.16, 23.611], [91.156, 23.671], [91.199, 23.647], [91.209, 23.686], [91.154, 23.689], [91.157, 23.742], [91.197, 23.751], [91.219, 23.736], [91.227, 23.792], [91.254, 23.837], [91.23, 23.881], [91.246, 23.913], [91.233, 23.927], [91.276, 23.922], [91.264, 23.944], [91.285, 23.982], [91.288, 23.968], [91.3, 23.972], [91.304, 23.998], [91.379, 23.975], [91.373, 24.003], [91.397, 24.05], [91.375, 24.108], [91.473, 24.102], [91.586, 24.073], [91.594, 24.096], [91.638, 24.103], [91.635, 24.138], [91.66, 24.189], [91.648, 24.218], [91.665, 24.233], [91.688, 24.162], [91.759, 24.142], [91.745, 24.247], [91.816, 24.21], [91.845, 24.226], [91.855, 24.213], [91.845, 24.191], [91.874, 24.174], [91.885, 24.139], [91.902, 24.137], [91.941, 24.268], [91.92, 24.337], [91.957, 24.357], [91.996, 24.322], [91.97, 24.384], [91.986, 24.377], [91.997, 24.394], [92.09, 24.372], [92.122, 24.382], [92.137, 24.425], [92.165, 24.419], [92.155, 24.523], [92.169, 24.532], [92.212, 24.504], [92.224, 24.517], [92.254, 24.678], [92.296, 24.736], [92.279, 24.746], [92.289, 24.785], [92.273, 24.827], [92.242, 24.842], [92.248, 24.886], [92.233, 24.9], [92.3, 24.916], [92.4, 24.849], [92.438, 24.856], [92.445, 24.872], [92.488, 24.871], [92.488, 24.947], [92.449, 24.939], [92.468, 24.964], [92.42, 24.967], [92.425, 25.029], [92.341, 25.049], [92.349, 25.073], [92.335, 25.078], [92.311, 25.069], [92.228, 25.094], [92.196, 25.108], [92.219, 25.117], [92.189, 25.136], [92.184, 25.118], [92.16, 25.127], [92.166, 25.136], [92.136, 25.139], [92.133, 25.16], [92.073, 25.185], [92.004, 25.186], [91.972, 25.168], [91.914, 25.181], [91.774, 25.163], [91.755, 25.177], [91.748, 25.14], [91.704, 25.16], [91.692, 25.137], [91.638, 25.122], [91.621, 25.143], [91.602, 25.142], [91.61, 25.177], [91.577, 25.172], [91.557, 25.15], [91.471, 25.134], [91.469, 25.152], [91.287, 25.185], [91.268, 25.207], [91.252, 25.195], [91.07, 25.198], [90.862, 25.158], [90.806, 25.166], [90.78, 25.186], [90.733, 25.155], [90.71, 25.168], [90.698, 25.157], [90.676, 25.176], [90.666, 25.166], [90.663, 25.198], [90.641, 25.174], [90.509, 25.175], [90.441, 25.145], [90.371, 25.163], [90.33, 25.194], [90.112, 25.225], [90.055, 25.261], [89.981, 25.281], [89.967, 25.304], [89.949, 25.293], [89.907, 25.308], [89.877, 25.285], [89.831, 25.296], [89.841, 25.315], [89.82, 25.381], [89.849, 25.493], [89.87, 25.511], [89.851, 25.539], [89.866, 25.546], [89.882, 25.617], [89.851, 25.712], [89.828, 25.73], [89.84, 25.767], [89.817, 25.814], [89.835, 25.841], [89.833, 25.871], [89.887, 25.945], [89.825, 25.945], [89.849, 25.949], [89.839, 25.968], [89.867, 25.972], [89.871, 25.981], [89.836, 26.013], [89.836, 25.982], [89.82, 25.988], [89.809, 26.043], [89.806, 26.044], [89.802, 26.031], [89.791, 26.018], [89.802, 26.04], [89.774, 26.038], [89.799, 26.06], [89.795, 26.087], [89.781, 26.083], [89.783, 26.106], [89.757, 26.109], [89.767, 26.131], [89.748, 26.157], [89.681, 26.164], [89.702, 26.174], [89.674, 26.201], [89.692, 26.212], [89.679, 26.238], [89.672, 26.22], [89.634, 26.229], [89.65, 26.19], [89.63, 26.196], [89.628, 26.184], [89.656, 26.181], [89.649, 26.164], [89.609, 26.181], [89.62, 26.168], [89.61, 26.154], [89.591, 26.157], [89.604, 26.117], [89.625, 26.129], [89.63, 26.118], [89.594, 26.102], [89.609, 26.088], [89.629, 26.107], [89.65, 26.063], [89.62, 26.053], [89.605, 26.064], [89.613, 26.052], [89.579, 26.026], [89.578, 25.969], [89.567, 25.98], [89.558, 25.965], [89.54, 25.97], [89.541, 26.006], [89.48, 25.996], [89.431, 26.011], [89.433, 26.038], [89.424, 26.047], [89.391, 26.023], [89.393, 26.007], [89.355, 26.008], [89.3, 26.05], [89.276, 26.049], [89.281, 26.066], [89.254, 26.064], [89.267, 26.092], [89.252, 26.091], [89.229, 26.124], [89.155, 26.139], [89.157, 26.163], [89.135, 26.181], [89.149, 26.209], [89.141, 26.236], [89.1, 26.279], [89.105, 26.316], [89.122, 26.287], [89.136, 26.32], [89.084, 26.322], [89.101, 26.337], [89.098, 26.359], [89.08, 26.363], [89.094, 26.394], [89.034, 26.395], [89.005, 26.422], [88.994, 26.413], [88.983, 26.447], [88.956, 26.46], [88.965, 26.451], [88.946, 26.448], [88.945, 26.426], [88.926, 26.432], [88.927, 26.407], [88.905, 26.409], [88.918, 26.403], [88.918, 26.36], [88.958, 26.362], [88.952, 26.332], [88.961, 26.352], [88.987, 26.348], [88.986, 26.333], [89.001, 26.33], [88.983, 26.309], [88.996, 26.29], [89.007, 26.304], [89.018, 26.29], [89.021, 26.309], [89.02, 26.289], [89.04, 26.276], [89.046, 26.295], [89.059, 26.293], [89.051, 26.242], [88.957, 26.24], [88.926, 26.284], [88.898, 26.289], [88.861, 26.273], [88.878, 26.233], [88.842, 26.231], [88.813, 26.256], [88.819, 26.294], [88.794, 26.31], [88.666, 26.263], [88.675, 26.32], [88.746, 26.322], [88.734, 26.328], [88.746, 26.347], [88.703, 26.334], [88.681, 26.379], [88.702, 26.388], [88.624, 26.435], [88.623, 26.471], [88.595, 26.471], [88.593, 26.45], [88.561, 26.456], [88.557, 26.485], [88.526, 26.481], [88.521, 26.511], [88.49, 26.51], [88.485, 26.541], [88.436, 26.545], [88.409, 26.635], [88.387, 26.612], [88.398, 26.604], [88.376, 26.595], [88.332, 26.482], [88.355, 26.447], [88.371, 26.488], [88.405, 26.486], [88.42, 26.466], [88.485, 26.46], [88.523, 26.361], [88.483, 26.35], [88.458, 26.377], [88.436, 26.336], [88.404, 26.329], [88.415, 26.315], [88.385, 26.313], [88.35, 26.282], [88.35, 26.22], [88.269, 26.186], [88.242, 26.189], [88.177, 26.148], [88.158, 26.08], [88.183, 26.073], [88.169, 26.045], [88.183, 26.027], [88.14, 26.013], [88.114, 25.959], [88.122, 25.948], [88.086, 25.917], [88.103, 25.889], [88.094, 25.874], [88.114, 25.855], [88.101, 25.843], [88.107, 25.815], [88.151, 25.776], [88.184, 25.802], [88.21, 25.787], [88.236, 25.809], [88.27, 25.808], [88.266, 25.782], [88.321, 25.738], [88.374, 25.717], [88.371, 25.697], [88.405, 25.684], [88.402, 25.673], [88.454, 25.665], [88.444, 25.597], [88.5, 25.584], [88.493, 25.559], [88.523, 25.535], [88.533, 25.542], [88.54, 25.508], [88.552, 25.521], [88.596, 25.506], [88.609, 25.516], [88.623, 25.497], [88.648, 25.496], [88.647, 25.478], [88.7, 25.471], [88.707, 25.5], [88.742, 25.505], [88.745, 25.488], [88.769, 25.498], [88.759, 25.525], [88.811, 25.523], [88.814, 25.488], [88.83, 25.49], [88.839, 25.459], [88.83, 25.417], [88.812, 25.41], [88.841, 25.398], [88.84, 25.364], [88.885, 25.326], [88.906, 25.338], [88.93, 25.304], [89.009, 25.303], [89.008, 25.265], [88.987, 25.274], [88.956, 25.255], [88.962, 25.209], [88.936, 25.211], [88.949, 25.177], [88.933, 25.181], [88.923, 25.165], [88.911, 25.18], [88.875, 25.179], [88.875, 25.196], [88.864, 25.19], [88.844, 25.214], [88.806, 25.171], [88.77, 25.19], [88.749, 25.177], [88.712, 25.208], [88.613, 25.204], [88.566, 25.175], [88.558, 25.193], [88.534, 25.188], [88.538, 25.198], [88.499, 25.21], [88.444, 25.197], [88.461, 25.149], [88.441, 25.128], [88.453, 25.079], [88.435, 25.056], [88.453, 25.037], [88.437, 25.007], [88.426, 25.016], [88.412, 24.999], [88.417, 24.974], [88.395, 24.969], [88.399, 24.945], [88.364, 24.953], [88.34, 24.94], [88.324, 24.916], [88.347, 24.892], [88.331, 24.87], [88.321, 24.884], [88.302, 24.872], [88.276, 24.898], [88.258, 24.878], [88.26, 24.919], [88.226, 24.96], [88.138, 24.936], [88.175, 24.86], [88.132, 24.836], [88.136, 24.805], [88.124, 24.823], [88.106, 24.78], [88.068, 24.769], [88.063, 24.722], [88.009, 24.668], [88.141, 24.511], [88.198, 24.462], [88.272, 24.441], [88.334, 24.381], [88.446, 24.379], [88.527, 24.344], [88.555, 24.293], [88.568, 24.327], [88.629, 24.305], [88.697, 24.315], [88.735, 24.276], [88.731, 24.173], [88.746, 24.147], [88.693, 24.111], [88.742, 24.057], [88.725, 24.042], [88.757, 24.032], [88.729, 23.996], [88.76, 24.006], [88.769, 23.983], [88.738, 23.983], [88.733, 23.911], [88.706, 23.916], [88.704, 23.899], [88.664, 23.882], [88.668, 23.869], [88.626, 23.865], [88.617, 23.877], [88.608, 23.862], [88.576, 23.862], [88.602, 23.817], [88.585, 23.814], [88.596, 23.805], [88.578, 23.786], [88.571, 23.783], [88.559, 23.786], [88.556, 23.784], [88.581, 23.761], [88.564, 23.711], [88.574, 23.667], [88.558, 23.649], [88.563, 23.637], [88.594, 23.641], [88.58, 23.603], [88.645, 23.609], [88.654, 23.556], [88.697, 23.516], [88.725, 23.512], [88.741, 23.48], [88.761, 23.478], [88.76, 23.49], [88.775, 23.48], [88.768, 23.49], [88.786, 23.507], [88.801, 23.497], [88.787, 23.469], [88.795, 23.443], [88.764, 23.448], [88.749, 23.401], [88.765, 23.368], [88.732, 23.352], [88.745, 23.308], [88.73, 23.32], [88.726, 23.299], [88.71, 23.313], [88.696, 23.302], [88.724, 23.273], [88.719, 23.255], [88.769, 23.245], [88.79, 23.218], [88.811, 23.221], [88.812, 23.256], [88.824, 23.233], [88.907, 23.236], [88.915, 23.213], [88.943, 23.206], [88.976, 23.224], [88.996, 23.215], [88.98, 23.213], [88.98, 23.183], [88.964, 23.193], [88.939, 23.177], [88.918, 23.129], [88.868, 23.101], [88.861, 23.077], [88.884, 23.04], [88.88, 23.006], [88.845, 23.01], [88.871, 22.979], [88.857, 22.969], [88.859, 22.944], [88.894, 22.952], [88.887, 22.933], [88.908, 22.92], [88.896, 22.913], [88.909, 22.88], [88.948, 22.879], [88.969, 22.845], [88.958, 22.796], [88.938, 22.793], [88.911, 22.758], [88.928, 22.718], [88.962, 22.695], [88.926, 22.65], [88.935, 22.626], [88.958, 22.616], [88.937, 22.591], [88.942, 22.562], [88.963, 22.549], [88.997, 22.47], [89.002, 22.43], [88.974, 22.412], [88.993, 22.391], [88.984, 22.327], [89.024, 22.298], [88.994, 22.287], [89.02, 22.268], [89.012, 22.254], [89.033, 22.259], [89.071, 22.197], [89.072, 22.148], [89.098, 22.154], [89.039, 22.1], [89.082, 22.011], [89.071, 22.011], [89.066, 21.936]] } }
  ]
};

export const calculateFuelDataFromAnalogVoltage = (voltage = 0, chartList = []) => {
  if (!chartList || chartList.length === 0) {
    return 0; // Return a default value if chartList is null or empty
  }

  if (chartList[0] && voltage < chartList[0].voltage) {
    return 0;
  }

  // Handle case where voltage is above the maximum in the list
  if (voltage > chartList[chartList.length - 1].voltage) {
    const lastTwoPoints = chartList.slice(-2);
    const slope = (lastTwoPoints[1].quantity - lastTwoPoints[0].quantity) /
      (lastTwoPoints[1].voltage - lastTwoPoints[0].voltage);

    const extrapolatedQuantity = lastTwoPoints[1].quantity +
      slope * (voltage - lastTwoPoints[1].voltage);

    return Number(Math.max(0, extrapolatedQuantity));
  }

  // Loop through the list and find the correct range
  for (let i = 0; i < chartList.length - 1; i++) {
    const current = chartList[i];
    const next = chartList[i + 1];

    // Check if the value lies between the current and next values
    if (voltage >= current.voltage && voltage <= next.voltage) {
      // Perform linear interpolation to estimate the qty
      const qtyDiff = next.quantity - current.quantity;
      const valueDiff = next.voltage - current.voltage;
      const valueRatio = (voltage - current.voltage) / valueDiff;

      // Calculate the interpolated quantity
      const interpolatedQty = current.quantity + qtyDiff * valueRatio;
      return Number(interpolatedQty);
    }
  }

  return chartList[chartList.length - 1] && chartList[chartList.length - 1].quantity || 0;
}

export const fuelSvgIcon = () => (
  <svg viewBox="0 0 512 512">
    <path style="fill:#C3C7C9;" d="M465.16,176.005v303.981c0,13.28-10.719,23.998-23.998,23.998H57.187
 c-13.28,0-23.998-10.719-23.998-23.998V32.014c0-13.28,10.72-23.998,23.998-23.998h239.984L465.16,176.005z M89.185,120.008h223.986
 l-63.995-63.995H89.185V120.008z"/>
    <path style="fill:#9A9EA1;" d="M33.188,455.987v23.998c0,13.279,10.72,23.998,23.998,23.998h383.975
 c13.279,0,23.998-10.72,23.998-23.998v-23.998H33.188z"/>
    <g>
      <rect x="257.171" y="447.969" style="fill:#FFFFFF;" width="16" height="16.032" />
      <rect x="193.183" y="447.969" style="fill:#FFFFFF;" width="16" height="16.032" />
    </g>
    <rect x="382.533" y="21.793" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 751.0543 -143.0738)" style="fill:#9DA1A4;" width="45.252" height="124.437" />
    <path style="fill:#F25B22;" d="M249.734,256c0,0,106.714,127.992,0,127.992C143.101,383.992,249.734,256,249.734,256z" />
    <path style="fill:#FFD311;" d="M249.174,176.005c0,0,199.987,239.984,0,239.984S249.174,176.005,249.174,176.005z M249.734,383.992
 c106.714,0,0-127.992,0-127.992S143.101,383.992,249.734,383.992z"/>
    <rect x="289.17" y="447.969" width="15.999" height="16.032" />
    <rect x="225.172" y="447.969" width="16" height="16.032" />
    <path d="M475.492,133.676l11.335-11.336L366.834,2.348L355.5,13.684l10.331,10.331l-20.662,20.662L300.492,0H57.187
 C39.535,0,25.173,14.362,25.173,32.014v447.971c0,17.653,14.362,32.014,32.014,32.014h383.975c17.653,0,32.014-14.362,32.014-32.014
 v-307.3l-28.678-28.678l20.663-20.663L475.492,133.676z M441.162,495.968H57.187c-8.813,0-15.983-7.169-15.983-15.983v-15.983
 h111.976v-16.032H41.204V184.021h111.976v-16.032H41.204V32.014c0-8.813,7.169-15.983,15.983-15.983h236.665l151.957,151.957
 h-100.64v16.032h111.976v263.95H345.169v16.032h111.976v15.983C457.144,488.798,449.975,495.968,441.162,495.968z M433.162,132.671
 l-76.657-76.657l20.662-20.662l76.658,76.657L433.162,132.671z"/>
    <path d="M345.169,128.024v-16.032H316.49l-63.995-63.995H81.169v63.995H57.187v16.032H345.169z M97.201,111.992V64.029h148.654
 l47.964,47.964H97.201z"/>
    <path d="M309.581,249.192c-24.835-42.873-53.06-76.891-54.248-78.318l-6.158-7.39l-6.158,7.39
 c-1.188,1.427-29.413,35.445-54.248,78.318c-34.279,59.173-44.485,104.496-30.334,134.71c12.464,26.611,42.994,40.103,90.74,40.103
 s78.275-13.493,90.74-40.103C354.066,353.688,343.86,308.365,309.581,249.192z M325.397,377.102
 c-9.594,20.485-35.24,30.872-76.221,30.872c-40.979,0-66.624-10.385-76.219-30.866c-11.617-24.795-1.388-66.186,29.582-119.7
 c17.373-30.02,36.927-56.145,46.64-68.569c9.686,12.389,29.167,38.412,46.534,68.389
 C326.758,310.825,337.023,352.277,325.397,377.102z"/>
    <path d="M255.892,250.867l-6.159-7.387l-6.157,7.39c-0.642,0.772-15.889,19.153-29.289,42.292
 c-18.928,32.683-24.42,58.021-16.321,75.309c7.317,15.619,24.735,23.538,51.77,23.538c27.059,0,44.491-7.924,51.808-23.551
 c8.096-17.291,2.597-42.626-16.344-75.305C271.789,270.016,256.535,251.637,255.892,250.867z M287.022,361.662
 c-4.45,9.497-16.995,14.313-37.288,14.313c-20.268,0-32.801-4.812-37.25-14.303c-5.568-11.879-0.038-33.295,15.571-60.299
 c7.648-13.233,16.115-25.044,21.68-32.394c5.568,7.349,14.041,19.159,21.694,32.388
 C287.052,328.368,292.588,349.781,287.022,361.662z"/>
    <polygon points="249.174,343.978 233.175,343.978 233.175,360.01 249.174,360.01 249.174,344.011 265.174,344.011 265.174,327.979 
 249.174,327.979 "/>
  </svg>
)

export const downloadJSONFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType })
  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}
